<style lang="less">
@import "./dispatchCenter.less";
@import "../less/common.less";
.activeH {
  visibility: hidden;
  height: 0px !important;
  padding: 0px !important;
}
</style>
<template>
  <el-row type="flex"
          :gutter="20"
          id="dispatchCenter"
          class="dispatchCenter row-bg common-layout"
          justify="space-between">
    <el-col class="common-layout-l"
            :span="5">
      <div class="block">
        <img class="warning"
             src="../image/warnpic.png"
             v-if="!isAutoWarning"
             @click="setDialogVisible=true" />
        <img class="warning"
             src="../image/warngif.gif"
             @click="showWarnInfo"
             v-else />
      </div>
      <div class="block">
        <span class="demonstration">时间：</span>
        <el-date-picker class="time-option"
                        v-model="timeValue"
                        align="right"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                        :clearable="false"
                        :editable="false"
                        size="medium"
                        @change="searchContent($event,true)"></el-date-picker>
      </div>
      <div class="block">
        <span class="demonstration">区域：</span>
        <template v-if="deptAreaOptions.length">
          <el-select v-model="areaValue"
                     collapse-tags
                     filterable
                     multiple
                     placeholder="请选择"
                     size="medium"
                     @change="changeArea">
            <el-option v-for="item in deptAreaOptions"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </template>
        <template v-else>
          <el-select collapse-tags
                     filterable
                     multiple
                     placeholder="请选择"
                     size="medium"
                     @change="changeArea">
            <el-option v-for="item in deptAreaOptions"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </template>
      </div>
      <div class="block">
        <span class="demonstration">门店：</span>
        <template v-if="deptOptions.length">
          <el-select v-model="deptValue"
                     collapse-tags
                     filterable
                     multiple
                     placeholder="请选择"
                     :clearable="true"
                     size="medium"
                     @change="searchContent">
            <el-option v-for="item in deptOptions"
                       :key="item.deptId"
                       :label="item.deptName"
                       :value="item.deptId"></el-option>
          </el-select>
        </template>
        <template v-else>
          <el-select collapse-tags
                     filterable
                     multiple
                     placeholder="请选择"
                     :clearable="true"
                     size="medium"
                     @change="searchContent">
            <el-option v-for="item in deptOptions"
                       :key="item.deptId"
                       :label="item.deptName"
                       :value="item.deptId"></el-option>
          </el-select>
        </template>
      </div>
      <div class="block">
        <template v-if="(radio!=2&&radio!=3)||(radio==3&&!modeDelivery)">
          <span class="demonstration">中类：</span>
          <template v-if="typeList1.length">
            <el-select v-model="productTypeId1"
                       collapse-tags
                       filterable
                       multiple
                       placeholder="请选择"
                       size="medium"
                       @change="changeProductType1">
              <el-option v-for="item in typeList1"
                         :key="item.productTypeId"
                         :label="item.productTypeName"
                         :value="item.productTypeId"></el-option>
            </el-select>
          </template>
          <template v-else>
            <el-select collapse-tags
                       filterable
                       multiple
                       placeholder="请选择"
                       size="medium"
                       @change="changeProductType1">
              <el-option v-for="item in typeList1"
                         :key="item.productTypeId"
                         :label="item.productTypeName"
                         :value="item.productTypeId"></el-option>
            </el-select>
          </template>
        </template>
      </div>
      <div class="block">
        <template v-if="(radio!=2&&radio!=3)||(radio==3&&!modeDelivery)">
          <span class="demonstration">小类：</span>
          <template v-if="typeOptions.length">
            <el-select v-model="typeValue"
                       collapse-tags
                       filterable
                       multiple
                       placeholder="请选择"
                       size="medium"
                       @change="changeProductType">
              <el-option v-for="item in typeOptions"
                         :key="item.productTypeId"
                         :label="item.productTypeName"
                         :value="item.productTypeId"></el-option>
            </el-select>
          </template>
          <template v-else>
            <el-select collapse-tags
                       filterable
                       multiple
                       placeholder="请选择"
                       size="medium"
                       @change="changeProductType">
              <el-option v-for="item in typeOptions"
                         :key="item.productTypeId"
                         :label="item.productTypeName"
                         :value="item.productTypeId"></el-option>
            </el-select>
          </template>
        </template>
        <div class="chart-img-txt">
          <div>
            <template v-if="modeDelivery&&radio==3">
              <div class="chart-txt">门店概览&nbsp;&nbsp;</div>
              <div class="chart-detail"
                   @click="editDesc">{{isEdit?"保存":"编辑"}}</div>
            </template>
            <template v-else>
              <div class="chart-txt">今日总货：￥{{totalMoney}}&nbsp;&nbsp;</div>
              <div class="chart-detail"
                   @click="showDetail">明细查询</div>
            </template>
          </div>
        </div>
      </div>
      <div class="block"
           v-show="!(modeDelivery&&radio==3)">
        <div class="chart-img"
             id="myChart"
             :style="{width: '150px', height: '150px'}"></div>
        <div class="chart-txt">
          <div class="color-block1">
            <div>&nbsp;</div>
            <span>昨日剩货</span>
          </div>
          <div>￥{{lastMoney}}</div>
          <div>{{lastMoneyPer}}%</div>
          <div class="color-block2">
            <div>&nbsp;</div>
            <span>今日到货</span>
          </div>
          <div>￥{{inMoney}}</div>
          <div>{{inMoneyPer}}%</div>
        </div>
      </div>
      <div class="block"
           v-show="!(modeDelivery&&radio==3)">
        <div class="chart-img"
             id="myChart2"
             :style="{width: '150px', height: '150px'}"></div>
        <div class="chart-txt">
          <div class="color-block2">
            <div>&nbsp;</div>
            <span>剩货</span>
          </div>
          <div>￥{{nowLastMoney}}</div>
        </div>
      </div>
      <div class="block detail-txt"
           v-show="!(modeDelivery&&radio==3)">
        <el-row :gutter="20">
          <el-col :span="24">
            <div>
              <div class="ico">&nbsp;</div>
              <div>营业额(元)</div>
              <div>{{salesMoney}}</div>
            </div>
            <div>
              <div>上周同期</div>
              <div>{{salesMoneyLast}}</div>
            </div>
            <div>
              <div>上年同期</div>
              <div>{{salesMoneyLastYear}}</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <div class="ico">&nbsp;</div>
              <div>客单数(笔)</div>
              <div>{{salesCount}}</div>
            </div>
            <div>
              <div>上周同期</div>
              <div>{{salesCountLast}}</div>
            </div>
            <div>
              <div>上年同期</div>
              <div>{{salesCountLastYear}}</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <div class="ico">&nbsp;</div>
              <div>客单价(元)</div>
              <div>{{salesPrice}}</div>
            </div>
            <div>
              <div>上周同期</div>
              <div>{{salesPriceLast}}</div>
            </div>
            <div>
              <div>上年同期</div>
              <div>{{salesPriceLastYear}}</div>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <div class="ico">&nbsp;</div>
              <div>上班人数</div>
              <div>{{workNum}}</div>
            </div>
            <div>
              <div>上周同期</div>
              <div>{{workNumLast}}</div>
            </div>
            <div>
              <div>上年同期</div>
              <div>{{workNumLastYear}}</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 20201125新增门店概览编辑&分类合计start -->
      <div class="block activity-txt"
           v-show="modeDelivery&&radio==3">
        <el-input type="textarea"
                  v-model="desc"
                  :autosize="{minRows: 5,maxRows: 5}"
                  placeholder="请输入活动信息"
                  :disabled="!isEdit"></el-input>
      </div>

      <div class="block class-total-info"
           v-show="modeDelivery&&radio==3&&templateId">
        <p class="chart-img-txt">分类合计&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <el-table class="table-common table-rowmores"
                  border
                  :data="tableDateTotal"
                  :row-class-name="tableRowClassName"
                  :cell-style="cellStyle"
                  :resizable="false"
                  highlight-current-row
                  show-summary
                  style="width: calc(100% + 25px);">
          <el-table-column prop="productTypeName"
                           label="分类"
                           min-width="100"
                           fixed
                           header-align="center">
            <template slot-scope="scope">
              <el-popover trigger="hover"
                          open-delay="200"
                          placement="top">
                <p>{{ scope.row.productTypeName }}</p>
                <div slot="reference"
                     class="name-wrapper">{{ scope.row.productTypeName }}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="inNum"
                           label="今日到货"
                           width="80"
                           header-align="center"
                           align="right"></el-table-column>
          <el-table-column prop="salesNum"
                           label="今日销售"
                           width="80"
                           header-align="center"
                           align="right"></el-table-column>
          <el-table-column prop="leftNum"
                           label="今日剩货"
                           width="80"
                           header-align="center"
                           align="right"></el-table-column>
          <el-table-column prop="requestNum"
                           label="昨日到货"
                           width="80"
                           header-align="center"
                           align="right"></el-table-column>
          <el-table-column prop="deliveryNum"
                           label="明日到货"
                           width="80"
                           header-align="center"
                           align="right"></el-table-column>
          <el-table-column prop="deliveryOtherNum"
                           label="预估到货"
                           width="80"
                           header-align="center"
                           align="right"></el-table-column>
        </el-table>
      </div>
      <!-- 20201125新增门店概览编辑&分类合计end -->
    </el-col>
    <el-col class="common-layout-r"
            id="search-content-h"
            :span="19">
      <div class="type-content-body"
           :style="{height:(dispatchHeight+10)+'px'}">
        <el-tabs class="type-border-card"
                 type="border-card"
                 v-model="radio"
                 @tab-click="loadSubTotal">
          <el-tab-pane label="时段销售"
                       :name="1"></el-tab-pane>
          <el-tab-pane label="时段库存"
                       :name="4"></el-tab-pane>
          <el-tab-pane label="分类汇总"
                       :name="2"></el-tab-pane>
          <el-tab-pane label="门店报货"
                       :name="3"></el-tab-pane>
        </el-tabs>
        <!-- loading弹出框start -->
        <div class="loadingcustom"
             :style="{width: width+20+'px'}"
             v-if="loading2">
          <span class="el-icon-loading"></span>
          <p>拼命加载中</p>
        </div>
        <!-- loading弹出框end -->
        <div class="nodata-div"
             v-if="radio==4?(!tableData1||tableData1.length==0):(radio==1?(!tableData2||tableData2.length==0):(radio==2?(!tableData3||tableData3.length==0):(!formData.tableData5||formData.tableData5.length==0)))">
          <div class="nodata">
            <img src="../image/nodata.png" />
            <p>
              <template v-if="deptValue.length==0">请先选择门店！</template>
              <template v-else-if="radio!=2&&typeValue.length==0">请先选择分类！</template>
              <template v-else>暂无数据！</template>
            </p>
          </div>
        </div>
        <div v-bind:class="{ activeH: radio==4?(!tableData1||tableData1.length==0):(radio==1?!tableData2||tableData2.length==0:(radio==2?!tableData3||tableData3.length==0:!formData.tableData5||formData.tableData5.length==0))}">
          <el-tabs id="dataDetail1"
                   class="product-data-detail"
                   v-model="activeName"
                   v-show="radio!=2">
            <div class="top-tip-template"
                 v-if="radio==3&&modeDelivery&&!templateId">
              请先选择模板！
            </div>
            <el-tab-pane label="折线图"
                         name="first"
                         v-bind:class="{ activeH:(radio==3&&modeDelivery&&!templateId)}">
              <div class="table-common-name stock-monthly-title">
                <h5>产品名称：{{currentProductName}}</h5>
                <h5>单价：{{price}}</h5>
                <h5>保质期：{{quality}}</h5>
                <h5>日平均销量：{{averSalesAmount}}</h5>
              </div>
              <div id="myChart3"
                   :style="{width: '100%', height: '221px'}"></div>
            </el-tab-pane>
            <el-tab-pane label="门店库存"
                         name="second"
                         style="width: 512px;"
                         v-bind:class="{ activeH:(radio==3&&modeDelivery&&!templateId)}">
              <!-- <h5>产品名称：{{currentProductName}}</h5> -->
              <div class="stock-monthly-title">
                <h5>产品名称：{{currentProductName}}</h5>
                <h5>单价：{{price}}</h5>
                <h5>保质期：{{quality}}</h5>
                <h5>日平均销量：{{averSalesAmount}}</h5>
              </div>
              <el-table class="table-common table-border"
                        :data="tableDataStockDept"
                        border
                        height="181"
                        :row-class-name="tableRowClassName"
                        :cell-style="cellStyle">
                <el-table-column label-class-name="product-data-index"
                                 type="index"
                                 label
                                 align="center"
                                 width="50"></el-table-column>
                <el-table-column prop="deptName"
                                 label="门店"></el-table-column>
                <el-table-column prop="num"
                                 label="当前库存"
                                 width="100"
                                 header-align="center"
                                 align="right"></el-table-column>
                <el-table-column prop="numx"
                                 label="销量"
                                 width="100"
                                 header-align="center"
                                 align="right"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="客单明细"
                         name="third"
                         v-bind:class="{ activeH:(radio==3&&modeDelivery&&!templateId)}">
              <div class="sales-product">
                <div>
                  <!-- <h5>产品名称：{{currentProductName}}</h5> -->
                  <div class="stock-monthly-title">
                    <h5>产品名称：{{currentProductName}}</h5>
                    <h5>单价：{{price}}</h5>
                    <h5>保质期：{{quality}}</h5>
                    <h5>日平均销量：{{averSalesAmount}}</h5>
                  </div>
                  <el-table class="table-common table-border"
                            :data="tableDataSalesDetail"
                            border
                            height="181"
                            :row-class-name="tableRowClassName"
                            :cell-style="cellStyle"
                            style="width: 552px;"
                            highlight-current-row
                            @row-click="rowclickSalesDetail">
                    <el-table-column label-class-name="product-data-index"
                                     type="index"
                                     label
                                     align="center"
                                     width="50"></el-table-column>
                    <el-table-column prop="salesNo"
                                     label="单号"></el-table-column>
                    <el-table-column prop="salesDate"
                                     label="时间"
                                     width="120"></el-table-column>
                    <el-table-column prop="amount"
                                     label="数量"
                                     width="100"
                                     header-align="center"
                                     align="right"></el-table-column>
                  </el-table>
                </div>
                <span>&nbsp;</span>
                <div class="sales-product-r">
                  <el-table class="table-common table-border"
                            :data="tableDataSalesProduct"
                            border
                            height="181"
                            width="750"
                            :row-class-name="tableRowClassName"
                            :cell-style="cellStyle">
                    <el-table-column label-class-name="product-data-index"
                                     type="index"
                                     label
                                     align="center"
                                     width="50"></el-table-column>
                    <el-table-column prop="productName"
                                     label="产品名称"
                                     width="160">
                      <template slot-scope="scope">
                        <el-popover trigger="hover"
                                    open-delay="200"
                                    placement="top">
                          <p>{{ scope.row.productName }}</p>
                          <div slot="reference"
                               class="name-wrapper">{{ scope.row.productName }}</div>
                        </el-popover>
                      </template>
                    </el-table-column>
                    <el-table-column prop="productCode"
                                     label="编码"
                                     width="160"></el-table-column>
                    <el-table-column prop="amount"
                                     label="销售量"
                                     width="120"
                                     header-align="center"
                                     align="right"></el-table-column>
                    <el-table-column prop="price"
                                     label="销售价"
                                     width="120"
                                     header-align="center"
                                     align="right"></el-table-column>
                    <el-table-column prop="money"
                                     label="销售金额"
                                     header-align="center"
                                     align="right"></el-table-column>
                  </el-table>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="产品出入库明细"
                         name="four"
                         v-bind:class="{ activeH:(radio==3&&modeDelivery&&!templateId)}">
              <div class="stock-monthly-title">
                <h5>产品名称：{{currentProductName}}</h5>
                <h5>单价：{{price}}</h5>
                <h5>保质期：{{quality}}</h5>
                <h5>日平均销量：{{averSalesAmount}}</h5>
              </div>
              <el-table class="table-common table-rowmore table-border"
                        :data="tableDataStock"
                        style="width: 100%"
                        :highlight-current-row="false">
                <el-table-column prop="productName"
                                 min-width="140"
                                 label="产品名称">
                  <template slot-scope="scope">
                    <el-popover trigger="hover"
                                open-delay="200"
                                placement="top">
                      <p>{{ scope.row.productName }}</p>
                      <div slot="reference"
                           class="name-wrapper">{{ scope.row.productName }}</div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column prop="accountCheckNum"
                                 label="账存"
                                 header-align="center"
                                 align="right"></el-table-column>
                <el-table-column prop="openingBalance"
                                 label="期初"
                                 header-align="center"
                                 align="right"></el-table-column>
                <el-table-column label="入库"
                                 header-align="center">
                  <el-table-column prop="affirmNum"
                                   label="确认收货"
                                   header-align="center"
                                   align="right"></el-table-column>
                  <el-table-column prop="shopFinishNum"
                                   label="完工"
                                   header-align="center"
                                   align="right"></el-table-column>
                  <el-table-column prop="shopOutSourcingNum"
                                   label="外购"
                                   header-align="center"
                                   align="right"></el-table-column>
                </el-table-column>
                <el-table-column label="出库"
                                 header-align="center">
                  <el-table-column prop="shopMoveOutNum"
                                   label="调出"
                                   header-align="center"
                                   align="right"></el-table-column>
                  <el-table-column prop="shopReturnNum"
                                   label="退货报废"
                                   header-align="center"
                                   align="right"></el-table-column>
                  <el-table-column prop="salesNum"
                                   label="销售"
                                   header-align="center"
                                   align="right"></el-table-column>
                </el-table-column>
                <el-table-column prop="lastSalesTime"
                                 label="末笔时间"
                                 width="120"
                                 header-align="center"
                                 align="center"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="单品表"
                         name="five"
                         v-bind:class="{ activeH:(radio==3&&modeDelivery&&!templateId)}">
              <div class="stock-monthly-title">
                <h5>产品名称：{{currentProductName}}</h5>
                <h5>单价：{{price}}</h5>
                <h5>保质期：{{quality}}</h5>
                <h5>日平均销量：{{averSalesAmount}}</h5>
              </div>
              <el-table class="table-common table-border"
                        :data="tableDataStockMonthLy"
                        border
                        style="width: 100%"
                        height="186"
                        :row-class-name="tableRowClassName"
                        :cell-style="cellStyle"
                        :resizable="false">
                <el-table-column v-for="(item,index) in columnStockMonthLy"
                                 :key="index"
                                 :prop="item.column"
                                 :width="110"
                                 header-align="center"
                                 :align="index>0?'right':'center'"
                                 :label="index>2?item.time+(index==3?'（今）':'（'+item.day+'）'):item.time"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="单品图"
                         name="six"
                         v-bind:class="{ activeH:(radio==3&&modeDelivery&&!templateId)}">
              <div class="stock-monthly-title table-common-name">
                <h5>产品名称：{{currentProductName}}</h5>
                <h5>单价：{{price}}</h5>
                <h5>保质期：{{quality}}</h5>
                <h5>日平均销量：{{averSalesAmount}}</h5>
              </div>
              <div id="myChart4"
                   :style="{height: '206px',width: width+'px',top:'12px'}"></div>
            </el-tab-pane>

          </el-tabs>
          <el-tabs id="dataDetail2"
                   class="product-data-detail"
                   v-model="activeName"
                   v-show="radio==2">
            <el-tab-pane label="折线图"
                         name="first">
              <div class="table-common-name radio-stock-name stock-monthly-title">
                <h5>分类名称：{{currentProductTypeName}}</h5>
                <h5>平均销售：{{averSalesAmount}}</h5>
              </div>
              <div id="myChart5"
                   :style="{height: '211px',width: width+'px'}"></div>
            </el-tab-pane>
            <el-tab-pane label="月明细表"
                         name="second">
              <div class="stock-monthly-title">
                <h5>分类名称：{{currentProductTypeName}}</h5>
                <h5>平均销售：{{averSalesAmount}}</h5>
              </div>
              <el-table class="table-common table-border table-monthLy"
                        :data="tableDataTypeMonthLy"
                        border
                        :style="width+'px'"
                        height="181"
                        :row-class-name="tableRowClassName"
                        :cell-style="cellStyle"
                        :resizable="false">
                <el-table-column v-for="(item,index) in columnTypeMonthLy"
                                 :key="index"
                                 :prop="item.column"
                                 :width="110"
                                 header-align="center"
                                 :align="index>0?'right':'center'"
                                 :label="index>2?item.time+(index==3?'（今）':'（'+item.day+'）'):item.time"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
          <div class="product-data">
            <div class="product-data-search">
              <el-radio-group class="radio-stock"
                              v-model="radioStock"
                              @change="loadSubTotal"
                              v-bind:class="{ activeH: radio!==2}">
                <el-radio :label="0">金额</el-radio>
                <el-radio :label="1">数量</el-radio>
              </el-radio-group>
              <div class="mode-delivery"
                   v-if="modeDelivery&&radio==3">
                模板：<el-select size="small"
                           v-model="templateId"
                           placeholder="请选择模板"
                           @change="changeTemplate">
                  <!-- requestDeptId: "" targetDeptId: "" -->
                  <el-option v-for="item in templateList"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id+'&&'+item.requestDeptId+'&&'+item.targetDeptId+'&&'+item.jhDays">
                  </el-option>
                </el-select>
                <template v-if="templateId">
                  到货日期：<el-tag type="info">{{deliveryDate}}</el-tag>
                  <el-checkbox class="is-predict-check"
                               v-model="isPredict"
                               text-color="red"
                               fill="red"
                               size="small"
                               @change="isPredictFun">预估</el-checkbox>
                  <el-checkbox v-model="isOrder">订单</el-checkbox>
                  <el-checkbox v-model="isSupply">补货</el-checkbox>
                  <el-button type="primary"
                             size="mini"
                             @click="saveGoodsRequest">保存</el-button>
                </template>
              </div>
              <el-checkbox class="time-set-btn model-set"
                           v-model="modeDelivery"
                           v-if="radio==3"
                           @change="deliveryFun">报货模式</el-checkbox>
              <el-button class="time-set-btn"
                         type="text"
                         @click="exportExcel(radio)">导出</el-button>
              <!-- v-if="radio=='1'||radio=='0'||radio=='3'" -->
              <el-button class="time-set-btn"
                         type="text"
                         @click="setTime">设置</el-button>
            </div>
            <!-- <el-tab-pane label="时段销售"
                       :name="1"></el-tab-pane>
          <el-tab-pane label="时段库存"
                       :name="4"></el-tab-pane>
          <el-tab-pane label="分类汇总"
                       :name="2"></el-tab-pane>
          <el-tab-pane label="门店报货"
                       :name="3"></el-tab-pane> -->
            <!-- 时段库存 -->
            <el-table class="table-common table-roll"
                      :data="tableData1"
                      border
                      @row-click="rowclick"
                      :height="height-36"
                      :row-class-name="tableRowClassName"
                      :cell-style="cellStyle"
                      :resizable="false"
                      highlight-current-row
                      v-if="radio==4">
              <el-table-column label-class-name="product-data-index"
                               type="index"
                               label
                               align="center"
                               fixed
                               width="50"></el-table-column>
              <el-table-column prop="productCode"
                               label="编码"
                               fixed
                               header-align="center"></el-table-column>
              <el-table-column prop="productName"
                               label="产品名称"
                               fixed
                               min-width="140"
                               header-align="center">
                <template slot-scope="scope">
                  <el-popover trigger="hover"
                              open-delay="200"
                              placement="top">
                    <p>{{ scope.row.productName }}</p>
                    <div slot="reference"
                         class="name-wrapper">{{ scope.row.productName }}</div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="sumABC"
                               label="ABC"
                               header-align="center"></el-table-column>
              <el-table-column prop="6"
                               label="6点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="6&5"
                               label="6点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="7"
                               label="7点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="7&5"
                               label="7点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="8"
                               label="8点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="8&5"
                               label="8点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="9"
                               label="9点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="9&5"
                               label="9点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="10"
                               label="10点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="10&5"
                               label="10点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="11"
                               label="11点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="11&5"
                               label="11点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="12"
                               label="12点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="12&5"
                               label="12点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="13"
                               label="13点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="13&5"
                               label="13点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="14"
                               label="14点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="14&5"
                               label="14点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="15"
                               label="15点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="15&5"
                               label="15点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="16"
                               label="16点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="16&5"
                               label="16点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="17"
                               label="17点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="17&5"
                               label="17点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="18"
                               label="18点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="18&5"
                               label="18点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="19"
                               label="19点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="19&5"
                               label="19点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="20"
                               label="20点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="20&5"
                               label="20点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="21"
                               label="21点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="21&5"
                               label="21点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="22"
                               label="22点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="22&5"
                               label="22点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="23"
                               label="23点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="23&5"
                               label="23点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="24"
                               label="24点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
            </el-table>

            <!-- 时段销售 -->
            <el-table class="table-common table-roll"
                      :data="tableData2"
                      border
                      style="width: 100%"
                      @row-click="rowclick"
                      :height="height-36"
                      :row-class-name="tableRowClassName"
                      :cell-style="cellStyle"
                      :resizable="false"
                      highlight-current-row
                      v-else-if="radio==1">
              <el-table-column label-class-name="product-data-index"
                               type="index"
                               label
                               align="center"
                               fixed
                               width="50"></el-table-column>
              <el-table-column prop="productCode"
                               label="编码"
                               fixed
                               header-align="center"></el-table-column>
              <el-table-column prop="productName"
                               label="产品名称"
                               fixed
                               min-width="140"
                               header-align="center">
                <template slot-scope="scope">
                  <el-popover trigger="hover"
                              open-delay="200"
                              placement="top">
                    <p>{{ scope.row.productName }}</p>
                    <div slot="reference"
                         class="name-wrapper">{{ scope.row.productName }}</div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="sumABC"
                               label="ABC"
                               header-align="center"></el-table-column>
              <el-table-column prop="6"
                               label="6点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="6&5"
                               label="6点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="7"
                               label="7点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="7&5"
                               label="7点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="8"
                               label="8点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="8&5"
                               label="8点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="9"
                               label="9点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="9&5"
                               label="9点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="10"
                               label="10点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="10&5"
                               label="10点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="11"
                               label="11点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="11&5"
                               label="11点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="12"
                               label="12点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="12&5"
                               label="12点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="13"
                               label="13点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="13&5"
                               label="13点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="14"
                               label="14点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="14&5"
                               label="14点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="15"
                               label="15点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="15&5"
                               label="15点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="16"
                               label="16点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="16&5"
                               label="16点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="17"
                               label="17点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="17&5"
                               label="17点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="18"
                               label="18点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="18&5"
                               label="18点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="19"
                               label="19点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="19&5"
                               label="19点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="20"
                               label="20点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="20&5"
                               label="20点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="21"
                               label="21点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="21&5"
                               label="21点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="22"
                               label="22点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="22&5"
                               label="22点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="23"
                               label="23点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
              <el-table-column prop="23&5"
                               label="23点半"
                               width="89"
                               header-align="center"
                               sortable
                               align="right"
                               v-if="valueTimes==30"></el-table-column>
              <el-table-column prop="24"
                               label="24点"
                               width="69"
                               header-align="center"
                               sortable
                               align="right"></el-table-column>
            </el-table>
            <el-table ref="summary"
                      class="table-common summary"
                      :data="tableData3"
                      border
                      style="width: 100%"
                      @row-click="rowclickSubtotal"
                      :height="height-36"
                      :row-class-name="tableRowClassName"
                      :cell-style="cellStyle"
                      :resizable="false"
                      highlight-current-row
                      :summary-method="getSummaries"
                      show-summary
                      v-bind:class="{ activeH: radio!=2}">
              <el-table-column label-class-name="product-data-index"
                               type="index"
                               label
                               align="center"
                               fixed
                               width="50"></el-table-column>
              <el-table-column prop="productName"
                               label="分类名称"
                               fixed
                               min-width="140"
                               header-align="center">
                <template slot-scope="scope">
                  <el-popover trigger="hover"
                              open-delay="200"
                              placement="top">
                    <p>{{ scope.row.productName }}</p>
                    <div slot="reference"
                         class="name-wrapper">{{ scope.row.productName }}</div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column v-for="(item,index) in columnSubtotal"
                               :key="index"
                               :prop="item.column"
                               width="160"
                               :label="item.time"
                               header-align="center"
                               align="center">
                <template slot-scope="scope">
                  <div style="width:33.33%">{{ scope.row[item.column]["salesAmount"]}}</div>
                  <div style="color:#45d266;border-left: 1px solid #EBEEF5;width:33.33%">{{ scope.row[item.column]["stockAmount"]}}</div>
                  <div style="color:#fbaa30;border-left: 1px solid #EBEEF5;width:33.33%">{{ scope.row[item.column]["returnAmount"]}}</div>
                </template>
              </el-table-column>
            </el-table>
            <!-- 门店报货 -->
            <!-- <el-input-number ref="inputNumber"></el-input-number> -->
            <el-form class="form-data"
                     :model="formData"
                     ref="formData">
              <div class="tip-template"
                   :style="{ height: (height-100)+'px'}"
                   v-if="radio==3&&modeDelivery&&!templateId">
                <div class="img-txt">
                  <img src="../image/nodata.png" />
                  <p>请先选择模板！</p>
                </div>
              </div>
              <el-table class="table-common table-rowmores table-roll"
                        border
                        @row-click="rowclick"
                        :data="formData.tableData5"
                        :row-class-name="tableRowClassName"
                        :cell-style="cellStyle"
                        :resizable="false"
                        highlight-current-row
                        :height="height-38"
                        style="width: 100%"
                        v-bind:class="{ activeH: radio!=3||(radio==3&&modeDelivery&&!templateId)}">
                <el-table-column label-class-name="product-data-index"
                                 type="index"
                                 label
                                 align="center"
                                 fixed
                                 width="50"></el-table-column>
                <el-table-column prop="productTypeName"
                                 label="分类名称"
                                 width="100"
                                 header-align="center"></el-table-column>
                <el-table-column prop="procuctCode"
                                 label="编码"
                                 width="90"
                                 header-align="center"></el-table-column>
                <el-table-column prop="productName"
                                 width="100"
                                 label="产品名称">
                  <!-- <template slot-scope="scope">
                    <el-popover trigger="hover"
                                open-delay="200"
                                placement="top">
                      <p>{{ scope.row.productName }}</p>
                      <div slot="reference"
                           class="name-wrapper">{{ scope.row.productName }}</div>
                    </el-popover>
                  </template> -->
                </el-table-column>
                <el-table-column prop="abc"
                                 label="ABC"
                                 width="70"
                                 header-align="center"></el-table-column>
                <el-table-column prop="price"
                                 label="单价"
                                 header-align="center"
                                 align="right"></el-table-column>
                <!-- :label="isPredict?'预估到货':'明日到货'columnTitle" -->
                <el-table-column prop="deliveryNum"
                                 :label="isPredict?predictTitle:columnTitle"
                                 width="80"
                                 header-align="center"
                                 v-if="modeDelivery">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData5.' + scope.$index + '.deliveryOtherNum'"
                                  :rules='rulesDelivery.deliveryOtherNum'
                                  v-if="isPredict">
                      <!-- {{'ref' + scope.$index}} -->
                      <!-- @keyup.enter.native="nextFocus('ref', scope.$index, $event)"-->
                      <el-input-number :ref="'ref' + scope.$index"
                                       v-model="scope.row.deliveryOtherNum"
                                       size="small"
                                       :controls="false"
                                       placeholder="预估到货"
                                       @focus="focusInput($event)"
                                       @change="deliveryNumChange(scope.$index)"></el-input-number>
                    </el-form-item>
                    <el-form-item :prop="'tableData5.' + scope.$index + '.deliveryNum'"
                                  :rules='rulesDelivery.deliveryNum'
                                  v-else>
                      <!-- {{'ref2' + scope.$index}} -->
                      <!-- @keyup.enter.native="nextFocus('ref2', scope.$index, $event)" -->
                      <el-input-number :ref="'ref2' + scope.$index"
                                       v-model="scope.row.deliveryNum"
                                       size="small"
                                       :controls="false"
                                       placeholder="明日到货"
                                       @focus="focusInput($event)"
                                       @change="deliveryNumChange(scope.$index)"></el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="haveRequestNum"
                                 label="已报货"
                                 header-align="center"
                                 align="right"></el-table-column>
                <!-- label="明日报货" -->
                <el-table-column prop="haveRequestNumOther"
                                 :label="columnTitle"
                                 header-align="center"
                                 align="right"
                                 v-if="isPredict"></el-table-column>
                <el-table-column prop="accountCheckNum"
                                 label="账存"
                                 width="60"
                                 header-align="center"
                                 align="right"></el-table-column>
                <el-table-column prop="openingBalance"
                                 label="期初"
                                 width="60"
                                 header-align="center"
                                 align="right"></el-table-column>
                <el-table-column label="入库"
                                 width="60"
                                 header-align="center"
                                 align="right">
                  <el-table-column prop="factoryNum"
                                   label="工厂入库"
                                   header-align="center"
                                   align="right"></el-table-column>
                  <el-table-column prop="affirmNum"
                                   label="调拨入库"
                                   header-align="center"
                                   align="right"></el-table-column>
                  <el-table-column prop="shopFinishNum"
                                   label="完工"
                                   width="60"
                                   header-align="center"
                                   align="right"></el-table-column>
                  <el-table-column prop="shopOutSourcingNum"
                                   label="外购"
                                   width="60"
                                   header-align="center"
                                   align="right"></el-table-column>
                </el-table-column>
                <el-table-column label="出库"
                                 header-align="center"
                                 align="right">
                  <el-table-column prop="shopMoveOutNum"
                                   label="调拨"
                                   header-align="center"
                                   align="right"></el-table-column>
                  <el-table-column prop="shopReturnNum"
                                   label="退货报废"
                                   header-align="center"
                                   align="right"></el-table-column>
                  <el-table-column prop="salesNum"
                                   label="销售"
                                   header-align="center"
                                   align="right"></el-table-column>
                </el-table-column>
                <el-table-column prop="salesNumFive"
                                 header-align="center"
                                 align="right"
                                 :label="timeFiveValue == '17:00' ? '5点后' : '3点后'"></el-table-column>
                <el-table-column prop="salesNumFivePer"
                                 width="60"
                                 header-align="center"
                                 align="right"
                                 label="占比"></el-table-column>
                <el-table-column prop="lastSalesTime"
                                 width="90"
                                 header-align="center"
                                 align="center"
                                 label="末笔时间"></el-table-column>
              </el-table>
              <!-- <el-pagination v-if="modeDelivery"
                             background
                             @current-change="handleCurrentChange2"
                             @prev-click="handlePrev"
                             @next-click="handleNext"
                             :current-page="pageIndex2+1"
                             :page-size="pageSize2"
                             layout="prev, pager, next"
                             :total="totalCount">
              </el-pagination> -->
            </el-form>
          </div>
        </div>
      </div>
    </el-col>
    <!-- 设置实时预警 start :modal-append-to-body="false"-->
    <el-dialog class="setDialog dispatch"
               :title="setName"
               :visible.sync="setDialogVisible"
               width="70%"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               append-to-body>
      <p>预警百分比：</p>
      <p>您可以在此设置预警百分比区间，以确定预警值。</p>
      <p>营业额超出是指当前营业额超出对比数值的百分比。</p>
      <p>营业额低于是指当前营业额低于对比数值的百分比。</p>

      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm">
        <div class="set-params">
          <el-form-item prop="heightBound"
                        class="set-params-detail">
            <div>营业额超出：≥</div>
            <el-input v-model.trim="ruleForm.heightBound">
              <i slot="suffix">%</i>
            </el-input>
          </el-form-item>
          <el-form-item prop="lowBound"
                        class="set-params-detail">
            <div>营业额小于：≤</div>
            <el-input v-model.trim="ruleForm.lowBound">
              <i slot="suffix">%</i>
            </el-input>
          </el-form-item>
        </div>
        <p>对比时间段设置：</p>
        <p>自定义：选择区间的平均值，如：星期一，自定义：星期一、星期二、星期三，则本周星期一对比上周这三天的平均值。</p>
        <div class="set-params">
          <div class="set-params-detail-content"
               v-for="(item,index) in timeSet"
               :key="index">
            <div>{{item.weekName}}：</div>
            <el-popover placement="right-end"
                        width="290"
                        trigger="manual"
                        v-model="item.visible">
              <el-checkbox-group class="dispach-week-select"
                                 v-model="item.days"
                                 size="mini">
                <el-checkbox-button v-for="week in timeSet"
                                    :label="week.weekDays"
                                    :key="week.weekDays">{{week.weekName}}</el-checkbox-button>
              </el-checkbox-group>
              <div style="text-align: right; margin: 0">
                <el-button size="mini"
                           type="text"
                           @click="showDays(3, index)">关闭</el-button>
              </div>
              <el-radio-group v-model="item.type"
                              size="medium"
                              slot="reference"
                              @change="showDays($event,index)">
                <el-radio-button :label="0">上周同期</el-radio-button>
                <el-radio-button :label="1">昨天</el-radio-button>
                <el-radio-button :label="2">
                  <span @click="showDays(2, index)">自定义</span>
                </el-radio-button>
              </el-radio-group>
            </el-popover>
          </div>
        </div>
        <div class="submit-form">
          <el-button type="primary"
                     size="small"
                     :loading="true"
                     v-if="isloading">保存</el-button>
          <el-button type="primary"
                     size="small"
                     @click="saveEarlyWarningSet('ruleForm')"
                     v-else>保存</el-button>
          <el-button size="small"
                     @click="closeSetDialog">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- 设置实时预警 end -->
    <!-- 查看实时预警 start  :modal-append-to-body="true"  -->
    <el-dialog class="showDialog dispatch"
               :title="showName"
               :visible.sync="showDialogVisible"
               width="70%"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               append-to-body
               :show-close="false">
      <div class="search-params">
        <el-button type="primary"
                   size="small"
                   @click="setParams">参数配置</el-button>
      </div>
      <div class="search-params btn-search">
        <el-radio-group class="search-params"
                        v-model="SearchType"
                        @change="searchWarnInfo">
          <el-radio :label="0">异常下跌</el-radio>
          <el-radio :label="1">涨幅排行</el-radio>
          <el-radio :label="2">交易排序</el-radio>
        </el-radio-group>
        <el-button size="small"
                   @click="exportExcel(null)">导出</el-button>
      </div>
      <el-table class="table-common"
                border
                :data="tableData4"
                style="width: 100%"
                :row-class-name="tableRowClassName">
        <el-table-column label-class-name="product-data-index"
                         type="index"
                         label
                         align="center"
                         fixed
                         width="50"></el-table-column>
        <el-table-column prop="deptName"
                         label="门店名称"
                         header-align="center"></el-table-column>
        <el-table-column prop="money"
                         label="当前营业额"
                         align="right"
                         header-align="right"></el-table-column>
        <el-table-column prop="moneyLast"
                         label="对比营业额"
                         align="right"
                         header-align="center"></el-table-column>
        <el-table-column prop="moneyBalance"
                         label="相差营业额"
                         align="right"
                         header-align="center"></el-table-column>
        <el-table-column prop="percent"
                         label="百分比"
                         align="right"
                         header-align="center">
          <template slot-scope="scope">{{ scope.row.percent }}%</template>
        </el-table-column>
      </el-table>
      <el-pagination background
                     layout="prev, pager, next"
                     :total="total"
                     :current-page="PageIndex+1"
                     @current-change="changeCurrentPage"
                     @prev-click="changeCurrentPage"
                     @next-click="changeCurrentPage"></el-pagination>
      <div class="submit-form">
        <el-button size="small"
                   @click="showDialogVisible=false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 查看实时预警 end -->
    <stockDetail :timeValue="timeValue"
                 :deptAreaOptions="deptAreaOptions"
                 :deptOptions="deptOptions"
                 :stockDetailDialogVisible="stockDetailDialog"
                 @close_stockDetail="closeStockDetail"></stockDetail>
    <!-- 导出弹框 start -->
    <el-dialog class="exportDialog"
               :visible.sync="centerDialogVisible"
               width="30%"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               append-to-body
               center>
      <el-progress class="exportProgress"
                   :text-inside="false"
                   :show-text="false"
                   :stroke-width="16"
                   :percentage="percentage"></el-progress>
      <p>{{percenttxt}}</p>
    </el-dialog>
    <!-- 导出弹框 end -->
    <el-dialog class="exportTip"
               title="导出范围"
               :visible.sync="exportDialogVisible"
               width="30%"
               append-to-body>
      <el-radio-group v-model="isExportAll">
        <el-radio :label="false">当前页</el-radio>
        <el-radio :label="true">全部</el-radio>
      </el-radio-group>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   @click="exportDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="handleExportData(null)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 时间段设置弹出框 start -->
    <timeSet :radio="radio"
             :searchFlag="searchFlag"
             :valueTimes="valueTimes"
             :timeSetDialogVisible="timeSetDialog"
             :timeFiveValue="timeFiveValue"
             @close_timeSet="closeTimeSet"
             @close_classSet="closeClassSet"
             @close_timeFiveSet="closeTimeFiveSet"></timeSet>
    <!-- 时间段设置弹出框 end -->
  </el-row>
</template>
<script>
import deptApi from "@/api/api-dept";
import productApi from "@/api/api-product";
import salesApi from "@/api/api-sales";
import stockApi from "@/api/api-stock";
import earlyWarningSetApi from "@/api/api-earlyWarningSet";
import setApi from "@/api/api-set";

import common from "@/libs/common";
import { Message } from "element-ui";
import stockDetail from './stockDetail.vue'
import timeSet from './timeSet.vue'
import { MessageBox } from "element-ui";
import {
  localToken
} from '@/libs/util';
let loading;
// let loading1;
// let loading3;
// let loading4;
let weekNames = [
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
  "星期日"
];
let timeSetOption = [
  {
    weekDays: 1,
    weekName: "星期一",
    type: 0,
    days: [],
    visible: false
  },
  {
    weekDays: 2,
    weekName: "星期二",
    type: 0,
    days: [],
    visible: false
  },
  {
    weekDays: 3,
    weekName: "星期三",
    type: 0,
    days: [],
    visible: false
  },
  {
    weekDays: 4,
    weekName: "星期四",
    type: 0,
    days: [],
    visible: false
  },
  {
    weekDays: 5,
    weekName: "星期五",
    type: 0,
    days: [],
    visible: false
  },
  {
    weekDays: 6,
    weekName: "星期六",
    type: 0,
    days: [],
    visible: false
  },
  {
    weekDays: 7,
    weekName: "星期日",
    type: 0,
    days: [],
    visible: false
  }
];
export default {
  components: {
    stockDetail,
    timeSet
  },
  data () {
    var validateLow = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("不能为空"));
      }

      let regExp = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,1})?$/;
      if (!regExp.test(value)) {
        callback(new Error("最多一位小数的数字"));
      } else {
        if (value < 0 || value > 100) {
          callback(new Error("大于0小于100"));
        } else {
          callback();
        }
      }
    };
    var validateHeight = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("不能为空"));
      }

      let regExp = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,1})?$/;
      if (!regExp.test(value)) {
        callback(new Error("最多一位小数的数字"));
      } else {
        if (value < 0 || value > 100) {
          callback(new Error("大于0小于100"));
        } else {
          callback();
        }
      }
    };
    // 
    var validateDeliveryNum = (rule, value, callback) => {
      let index = Number(rule.field.split(".")[1])
      let requestMaxNum = this.formData.tableData5[index].requestMaxNum // 最大要货量为0不做最大限制
      let requestMinNum = this.formData.tableData5[index].requestMinNum // 最小要货量不为0做最小限制
      let requestNum = this.formData.tableData5[index].requestNum // 要货倍数为零不做要货倍数限制
      let val = Number(value)
      if (value) {
        val = val > 0 ? val : 0
        this.formData.tableData5 = this.formData.tableData5.map((item, i) => {
          if (index == i) {
            item["deliveryNum"] = common.toDecimal1(val)
          }
          return item
        })

        if (requestMaxNum && val > requestMaxNum) {
          callback(new Error("最大要货量为" + requestMaxNum));
        } else if (requestMinNum && val < requestMinNum) {
          callback(new Error("最小要货量为" + requestMinNum));
        } else if (requestNum && val % requestNum !== 0) {
          callback(new Error("要货倍数为" + requestNum));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var validateDeliveryOtherNum = (rule, value, callback) => {
      let index = Number(rule.field.split(".")[1])
      let requestMaxNum = this.formData.tableData5[index].requestMaxNum // 最大要货量为0不做最大限制
      let requestMinNum = this.formData.tableData5[index].requestMinNum // 最小要货量不为0做最小限制
      let requestNum = this.formData.tableData5[index].requestNum // 要货倍数为零不做要货倍数限制
      let val = Number(value)
      if (value) {
        val = val > 0 ? val : 0
        this.formData.tableData5 = this.formData.tableData5.map((item, i) => {
          if (index == i) {
            item["deliveryOtherNum"] = common.toDecimal1(val)
          }
          return item
        })

        if (requestMaxNum && val > requestMaxNum) {
          callback(new Error("最大要货量为" + requestMaxNum));
        } else if (requestMinNum && val < requestMinNum) {
          callback(new Error("最小要货量为" + requestMinNum));
        } else if (requestNum && val % requestNum !== 0) {
          callback(new Error("要货倍数为" + requestNum));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      loading2: false,
      currentRow: "",
      // 时间控件
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick (picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick (picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick (picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      timeValue: common.getTime(new Date()),
      // 区域
      deptAreaOptions: [],
      areaValue: [],
      oldDeptArea: [],
      // 门店
      deptOptions: [],
      oldSearchDeptType: [],
      deptValue: [], //"08EDC55C48B44CB5AC004D8C35339526",
      radio: 1,
      // 分类
      typeList1: [],
      productTypeId1: [],
      oldProductType1: ["all"],
      typeValue: [],
      typeOptions: [],
      oldProductType: [],
      salesMoney: 0, //营业额（元）
      salesCount: 0, //客单数（笔）
      salesPrice: 0, //客单价（元）
      workNum: 0, // 上班人数
      salesMoneyLast: 0,
      salesCountLast: 0,
      salesPriceLast: 0,
      workNumLast: 0,
      salesMoneyLastYear: 0,
      salesCountLastYear: 0,
      salesPriceLastYear: 0,
      workNumLastYear: 0,
      //出货剩货
      inMoney: 0, // 今日到货
      lastMoney: 0, // 昨日剩货
      outMoney: 0, // 出货
      nowLastMoney: 0, // 剩货
      inMoneyPer: 0, // 今日到货占比
      lastMoneyPer: 0, // 昨日剩货占比
      outMoneyPer: 0, // 出货占比
      nowLastMoneyPer: 0, // 剩货占比
      totalMoney: 0, // 今日总货量
      //tabs默认选项
      activeName: "first",
      //商品进销存明细
      tableData1: [],
      tableData2: [],
      tableData3: [], // 分类汇总数据
      tableData4: [], // 预警
      formData: { tableData5: [] }, // 门店报货
      columnSubtotal: [], // 分类汇总数据标题
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],
      // 门店报货
      tableDataStock: [],
      // 门店库存
      tableDataStockDept: [],
      // 客单明细
      tableDataSalesDetail: [],
      tableDataSalesProduct: [],
      averSalesAmount: null,// 平均销量
      price: null, // 单价
      quality: null,//保质期
      // 单品表
      tableDataStockMonthLy: [],
      columnStockMonthLy: [],
      dataMonthLy1: [],
      dataMonthLy2: [],
      dataMonthLy3: [],
      dataMonthLy4: [],
      dataMonthLy5: [],
      dataArrMonthLy: [],
      currentProductName: null,
      // 分类月汇总
      currentProductTypeName: null, // 当前分类
      columnTypeMonthLy: [], //分类月汇总表头
      tableDataTypeMonthLy: [], // 分类月汇总表数据
      radioStock: 0,
      dataTypeMonthLy1: [],
      dataTypeMonthLy2: [],
      dataTypeMonthLy3: [],
      dataTypeMonthLy4: [],
      dataTypeArrMonthLy: [],
      currentTime: common.getTime(new Date()),
      fullscreenLoading: false,
      height: $("#search-content-h").height() - 305,
      width: $("#search-content-h").width() - 20,
      setName: "设置实时预警",
      showName: "预警门店详情",
      SearchType: 1,
      setDialogVisible: false,
      showDialogVisible: false,
      isAutoWarning: false,
      timeSet: timeSetOption,
      ruleForm: {
        lowBound: 20,
        heightBound: 20
      },
      rules: {
        lowBound: [{ validator: validateLow, trigger: "blur" }],
        heightBound: [{ validator: validateHeight, trigger: "blur" }]
      },
      PageSize: 10,
      PageIndex: 0,
      totalPages: 0,
      total: 1,
      isloading: false,
      stockDetailDialog: false,
      // 导出弹框
      centerDialogVisible: false,
      percentage: 0,
      percenttxt: "导出数据100条,已处理50条,正在导出,请稍等",
      exportData: [],
      isExportAll: false,
      exportDialogVisible: false,
      // 实时预警详情
      tHeader: common.tHeader,
      filterVal: common.filterVal,
      // 分类汇总
      // subtotalTHeader: [],
      // subtotalFilterVal: [],
      // 门店报货
      stockTHeader: common.stockTHeader,
      stockFilterVal: common.stockFilterVal,
      // 时间设置弹出框
      timeSetDialog: false,
      dispatchHeight: $("#dispatchCenter").height() - 20,
      // 时间段设置（当前为1小时、0.5小时）
      valueTimes: 60,
      modeDelivery: false, // 是否开启报货模式
      deliveryDate: common.getLastDate(),
      isPredict: false,//是否预估 
      isOrder: false, //是否订单
      isSupply: false, //是否补货
      desc: null, // 活动描述
      columnsTotal: [],// 分类合计表头
      tableDateTotal: [],// 分类合计数据
      isEdit: false,
      searchFlag: 0, // 默认小类 0小类 1中类
      rulesDelivery: {
        deliveryNum: [{ validator: validateDeliveryNum, trigger: "blur" }],
        deliveryOtherNum: [{ validator: validateDeliveryOtherNum, trigger: "blur" }]
      },
      timeFiveValue: "17:00", //new Date(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate() + 1, 17, 0)
      pageIndex2: 0,
      pageSize2: 50,
      totalCount: 0,
      tableDataRecord: [], // 记录录入数据
      tableStockRequestSum: [], // 记录总结
      templateList: [], // 模板数据：选择报货模式获取报货模板，清空数据
      templateId: null, // 报货模板默认为空，有值时查询数据
      jhDays: 1, // 默认明日
      columnTitle: common.getLastDay(),// common.getLastDate()
      predictTitle: null
    };
  },
  methods: {
    focusInput (event) {
      event.currentTarget.select() // 全选
    },
    // 更换模板获取报货数据
    changeTemplate (value) {
      let that = this
      let arr = that.templateId.split('&&')
      that.jhDays = Number(arr[3])
      that.predictTitle = common.getLastDay(that.jhDays)
      if (that.isPredict) {
        that.deliveryDate = common.getLastDate(that.jhDays)
      } else {
        that.deliveryDate = common.getLastDate()
      }
      // that.deliveryDate = that.isPredict ? common.getLastDate(that.jhDays) : common.getLastDate()
      that.getProductTypeDetail()
      that.getStockRequestSum() // 获取分类汇总当切换到报货模式时下，首先隐藏分类汇总，切换模板时再次获取
    },
    // 20201204 无需分页 start
    // // 当前页改变时触发
    // handleCurrentChange2 (page) {
    //   let that = this
    //   that.pageIndex2 = page - 1
    //   that.getProductTypeDetail()
    // },
    // // 上一页按钮改变当前页后触发
    // handlePrev (page) {
    //   let that = this
    //   that.pageIndex2 = page - 1
    //   that.getProductTypeDetail()
    // },
    // // 下一页按钮改变当前页后触发
    // handleNext (page) {
    //   let that = this
    //   that.pageIndex2 = page - 1
    //   that.getProductTypeDetail()
    // },
    // 20201204 无需分页 end
    // 录入\修改明日到货
    deliveryNumChange (index) {
      let that = this
      let row = that.formData.tableData5[index] // 变动的行数据
      let column = that.isPredict ? "deliveryOtherNum" : "deliveryNum"
      // 记录填入的明日预估到货 start
      let len = 0
      that.tableDataRecord = that.tableDataRecord.map(item => {
        if (item.productId == row.productId) {
          len = 1
          item[column] = row[column]
        }
        return item
      })
      if (len == 0) {
        that.tableDataRecord.push(row)
      }
      // 记录填入的明日预估到货 end
      // 计算分类合计
      that.tableDateTotal = that.tableDateTotal.map(item => {
        if (item.productTypeId === row.productTypeId) {
          let num = 0
          that.tableDataRecord.filter(opt => {
            if (opt.productTypeId == row.productTypeId) {
              num += opt[column] ? Number(opt[column]) : 0
            }
          })
          item[column] = num
        }
        return item
      })
    },
    // 保存
    saveGoodsRequest () {
      let that = this
      let deliveryDate = that.deliveryDate
      let deptValue = that.deptValue
      let tableData5 = that.formData.tableData5 // 门店报货
      let item = []
      // isPredict?'预估到货':'明日到货' 
      if (that.isPredict) {
        item = tableData5.filter(item => item.deliveryOtherNum).map(item => {
          return {
            "productId": item.productId,
            "amount": Number(item.deliveryOtherNum)
          }
        })
      } else {
        item = tableData5.filter(item => item.deliveryNum).map(item => {
          return {
            "productId": item.productId,
            "amount": Number(item.deliveryNum)
          }
        })
      }

      if (!that.templateId) {
        Message({
          message: "请先选择模板，并输入报货信息！",
          type: "error"
        });
        return false
      }
      if (item.length == 0) {
        Message({
          message: "请先输入报货信息！",
          type: "error"
        });
        return false
      }

      let arr = that.templateId.split('&&')
      let dataGoods = {
        deliveryDate: deliveryDate,
        deptId: deptValue[0],
        isPredict: that.isPredict,
        isOrder: that.isOrder,
        isSupply: that.isSupply,
        templateId: arr[0],
        requestDeptId: arr[1],
        targetDeptId: arr[2],
        item: item
      }
      if (that.isSupply) {
        that.setGoodsRequest(dataGoods)
      } else {

        let data = {
          DeptId: deptValue[0], // 部门
          DeliveryDate: that.deliveryDate, // 日期
          IsOrder: that.isOrder, // 是否订单
          IsPredict: that.isPredict //是否预估
        }
        common.getGoodsRequest(data).then(
          res => {
            if (res.res > 0 && !that.isSupply) {
              const h = that.$createElement;
              MessageBox({
                message: h("div", null, [
                  h("i", {
                    class: "el-icon-warning message-login-title"
                  }),
                  h("span", { class: "message-login-txt" }, " 提示"),
                  h("p", { class: "message-login-content" }, "当前门店已有订单,您确认保存并覆盖？ ")
                ]),
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                beforeClose: (action, instance, done) => {
                  if (action === "confirm") {
                    that.setGoodsRequest(dataGoods)
                    done();
                  } else {
                    done();
                  }
                }
              });
            } else {
              that.setGoodsRequest(dataGoods)
            }
          },
          err => { }
        );
      }
    },
    // 保存
    setGoodsRequest (data) {
      common.setGoodsRequest(data).then(
        res => {
          this.getProductTypeDetail()
          Message({
            message: "门店报货成功！",
            type: "success"
          });
        },
        err => { }
      );
    },
    // 是否预估
    isPredictFun (value) {
      let that = this
      that.isPredict = value
      that.deliveryDate = that.isPredict ? common.getLastDate(that.jhDays) : common.getLastDate()
      that.tableDateTotal = JSON.parse(JSON.stringify(that.tableStockRequestSum))
      that.getProductTypeDetail()
    },
    // 切换保存和编辑
    editDesc () {
      let that = this
      // 当点击保存时保存并切换至不可编辑状态
      if (that.isEdit) {
        let deptValue = that.deptValue
        common.setDeptFact({
          "deptId": deptValue[0],
          "deptFact": that.desc
        }).then(
          res => {
            console.log("分类概览保存成功")
          },
          err => {
            console.log("分类概览保存失败")
          }
        );
      }
      that.isEdit = !that.isEdit
    },
    // 是否报货
    deliveryFun (value) {
      let that = this
      // 初始化
      that.deliveryDate = common.getLastDate()
      that.isPredict = false//是否预估 
      that.isOrder = false //是否订单
      that.isSupply = false //是否补货
      that.isEdit = false
      // 报货模式请求
      if (value) {
        let deptValue = that.deptValue
        if (!deptValue || (deptValue && deptValue.length > 1)) {
          Message({
            message: "请将门店选择设置为单个！",
            type: "error"
          });
          that.modeDelivery = false
          return false
        }
        that.templateId = null
        that.modeDelivery = value
        that.searchFlag = 0// 默认小类 0小类 1中类
        that.getDeptFact() // 获取概要
        that.getGoodsRequestTemplate() // 待开发，获取模板列表
      } else {
        // 非报货模式请求
        that.modeDelivery = value
        that.templateId = null
        that.getProductTypeDetail()
      }
    },
    // 获取模板列表
    getGoodsRequestTemplate () {
      let that = this
      let data = {
        deptId: that.deptValue[0], // 部门
      }
      common.getGoodsRequestTemplate(data).then(
        res => {
          that.templateList = res
        },
        err => { }
      );
    },
    // 报货分类汇总
    getStockRequestSum () {
      let that = this
      let deptValue = that.deptValue
      let arrType = (that.searchFlag ? that.productTypeId1 : that.typeValue).filter(item => item != 'all')
      let arr = that.templateId.split('&&')
      let data = {
        searchFlag: that.searchFlag, // 0小类 1中类
        productTypeIds: arrType, // 类别id
        deptId: deptValue[0], // 部门
        searchDate: new Date(), // 报货日期
        templateId: arr[0]
      }
      common.getStockRequestSum(data).then(
        res => {
          that.tableDateTotal = res.items
          that.tableStockRequestSum = JSON.parse(JSON.stringify(res.items))
          // deliveryNum: 22
          // inNum: 16
          // leftNum: 217
          // requestNum: 22
          // salesNum: 7 
        },
        err => { }
      );
    },
    //获取门店概览
    getDeptFact () {
      let that = this
      let deptValue = that.deptValue
      if (deptValue && deptValue.length > 0) {
        common.getDeptFact(deptValue[0]).then(
          res => {
            that.desc = res.deptFact
          },
          err => { }
        );
      }
    },
    // 设置分类类型
    closeClassSet (value) {
      let that = this
      that.searchFlag = value
      if (that.radio == 2) {
        // 分类汇总查询
        that.loadSubTotal()
      } else {
        // 报货分类汇总
        that.getStockRequestSum()
        // 获取门店报货
        that.getProductTypeDetail()
      }
      that.timeSetDialog = false
    },
    // 设置时间节点
    closeTimeFiveSet (value) {
      let that = this
      if (value) {
        that.timeFiveValue = value
        if (that.radio == 3) {
          // 报货分类汇总
          that.getStockRequestSum()
          // 获取门店报货
          that.getProductTypeDetail()
        } else {
          // 分类汇总查询
          that.loadSubTotal()
        }
      }
      that.timeSetDialog = false
    },
    // 设置时间段
    closeTimeSet (value) {
      let that = this
      if (value) {
        that.valueTimes = value
        if (that.radio == 1 || that.radio == 4) {
          that.searchProduct()
        } else if (that.radio == 3) {
          // 获取门店报货
          that.getProductTypeDetail()
        }
      }
      that.timeSetDialog = false
    },
    // 设置时间段
    setTime () {
      this.timeSetDialog = true
    },
    // 分类汇总合计添加
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      let currentSums = { 'index': '', 'productName': '合计' }
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '';
          return;
        }
        if (index === 1) {
          sums[index] = '合计';
          return;
        }

        let returnAmountTotal = 0
        let salesAmountTotal = 0
        let stockAmountTotal = 0
        const values = data.map(item => {
          let temp = item[column.property]
          returnAmountTotal += Number(temp.returnAmount)
          salesAmountTotal += Number(temp.salesAmount)
          stockAmountTotal += Number(temp.stockAmount)
          return temp
        });
        sums[index] = common.formatDecimal(salesAmountTotal + '') + '|' + common.formatDecimal(stockAmountTotal + '') + '|' + common.formatDecimal(returnAmountTotal + '');
        currentSums[column.property + 's'] = sums[index]
      });
      this.currentSums = currentSums
      return sums;
    },
    //定义导出Excel表格事件
    exportExcel (val = null) {
      let that = this;
      let len = 0
      if (!val) {
        len = that.tableData4.length
      }
      // 时段销售
      if (val && that.radio == 1) {
        len = that.tableData2.length
      }
      // 时段库存
      if (val && that.radio == 4) {
        len = that.tableData1.length
      }
      // 分类汇总
      if (val && that.radio == 2) {
        len = that.tableData3.length
      }
      // 门店报货
      if (val && that.radio == 3) {
        len = that.formData.tableData5.length
      }
      if (len == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先查找数据！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      if (!val) {
        that.exportDialogVisible = true
      } else {
        that.handleExportData(val)
      }
    },

    handleExportData (val) {
      let that = this
      let filterVal = []
      let tHeader = []
      let title = ""
      var dataExport = []
      // 门店预警详情导出
      if (!val) {
        tHeader = JSON.parse(JSON.stringify(that.tHeader)).filter((item, index) => index != 2)
        filterVal = JSON.parse(JSON.stringify(that.filterVal)).filter((item, index) => index != 2)
        dataExport = that.isExportAll ? that.exportData : that.tableData4;  //把要导出的数据tableData存到list
        title = "预警门店详情"
        that.exportDialogVisible = false
      }

      // 时段销售
      if (val && that.radio == 1) {
        tHeader = JSON.parse(JSON.stringify(common.saleTHeader))
        filterVal = JSON.parse(JSON.stringify(common.saleFilterVal))
        dataExport = that.tableData2;  //把要导出的数据tableData存到list
        title = "时段销售"
      }
      // 时段库存
      if (val && that.radio == 4) {
        tHeader = JSON.parse(JSON.stringify(common.reserveTHeader))
        filterVal = JSON.parse(JSON.stringify(common.reserveFilterVal))
        dataExport = that.tableData1;  //把要导出的数据tableData存到list
        title = "时段库存"
      }

      // 分类汇总导出
      if (val && that.radio == 2) {
        tHeader = ['序号', '分类名称']
        filterVal = ['index', 'productName']
        that.columnSubtotal.map(item => {
          tHeader.push(item.time)
          filterVal.push(item.column + 's')
        })
        dataExport = []
        that.tableData3.map((item, index) => {
          let temp = item
          temp['index'] = index + 1
          for (var key in item) {
            let value = ''
            if (key !== 'index' && key !== 'productName' && key !== 'id') {
              value = item[key].salesAmount + '|' + item[key].stockAmount + '|' + item[key].returnAmount
              temp[key + 's'] = value
            }
          }
          dataExport.push(temp)
          return item
        }) //把要导出的数据tableData存到list
        dataExport.push(that.currentSums)
        title = "分类汇总"
      }
      // 门店报货
      if (val && that.radio == 3) {
        tHeader = JSON.parse(JSON.stringify(that.stockTHeader))
        tHeader[16] = that.timeFiveValue == '17:00' ? '5点后' : '3点后'
        filterVal = JSON.parse(JSON.stringify(that.stockFilterVal))
        dataExport = that.formData.tableData5;  //把要导出的数据tableData存到list
        title = "门店报货"
      }
      that.exportDataFun(filterVal, tHeader, dataExport, title)
    },
    // 公用导出
    exportDataFun (filterVal, tHeader, dataExport, title) {
      let that = this
      that.centerDialogVisible = true;
      var iSpeed = 1;
      that.percentage = 0;
      that.percenttxt =
        "导出数据" + dataExport.length + "条，已处理0条，正在导出,请稍等";
      var obj = setInterval(function () {
        iSpeed += 6;
        if (iSpeed >= 100) {
          // 设置达到多少进度后停止
          that.percentage = 100;
          that.percenttxt = "导出数据" + dataExport.length + "条，已完成！";
          clearInterval(obj);
          setTimeout(() => {
            that.centerDialogVisible = false;
          }, 200);
        } else {
          that.percentage = iSpeed;
          that.percenttxt =
            "导出数据" +
            dataExport.length +
            "条，已处理" +
            parseInt(dataExport.length * (iSpeed / 100)) +
            "条，正在导出，请稍等";
        }
      }, 12); // 20毫秒后函数执行一次
      require.ensure([], () => {
        const { export_json_to_excel } = require('@/Excel/Export2Excel');//注意这个Export2Excel路径
        const data = localToken.formatJson(filterVal, dataExport);
        export_json_to_excel(tHeader, data, title + common.getDateDetail());//最后一个是表名字
      })
    },
    showDetail () { this.stockDetailDialog = true },
    closeStockDetail (val) { this.stockDetailDialog = false },
    getSalesWarn () {
      let that = this;
      let data = {
        SearchType: that.SearchType, //0 异常下跌 1涨幅排行  2交易排序
        // OrderType:, //OrderType 排序方式  不传为默认排序 0按营业额降序 1按营业额升序  2对比营业额降序 3对比营业额升序 4按相差营业额降序  5按相差营业额升序  6按百分比降序 7按百分比升序
        PageSize: that.PageSize,
        PageIndex: that.PageIndex
      }
      common.getSalesWarning(data).then(
        res => {
          that.total = res.totalCount;
          that.totalPages = res.totalPages
          that.tableData4 = res.items.map((item, index) => {
            item["index"] = index + 1
            return item
          })
          // 获取全部 exportData
          that.getAllRequestTableData().then(allres => {
            if (allres) {
              that.exportData = allres.map((item, index) => { item['index'] = index + 1; return item })
            }
          })
        },
        err => { }
      );
    },
    getAllRequestTableData () {
      let that = this
      let data = {
        SearchType: that.SearchType, //0 异常下跌 1涨幅排行  2交易排序
        // OrderType:, //OrderType 排序方式  不传为默认排序 0按营业额降序 1按营业额升序  2对比营业额降序 3对比营业额升序 4按相差营业额降序  5按相差营业额升序  6按百分比降序 7按百分比升序
        PageSize: that.PageSize,
        PageIndex: that.PageIndex
      }
      let exportTableData = []
      let promiseArr = []
      promiseArr = Array.apply(null, Array(that.totalPages)).map(function (
        item,
        index
      ) {
        data['PageIndex'] = index
        return new Promise((resolve, reject) => {
          common.getSalesWarning(data, true).then(
            res => {
              exportTableData = exportTableData.concat(res.items)
              resolve(res)
            },
            err => {
              reject(err)
            }
          )
        })
      })
      return new Promise((resolve, reject) => {
        Promise.all(promiseArr).then(
          res => {
            resolve(
              promiseArr.length === that.totalPages ? exportTableData : null
            )
          },
          err => {
            reject(err)
          }
        )
      })
    },
    changeCurrentPage (PageIndex) {
      let that = this;
      PageIndex = PageIndex - 1;
      if (PageIndex != that.PageIndex) {
        that.PageIndex = PageIndex;
        that.getSalesWarn();
      }
    },
    searchWarnInfo () {
      let that = this;
      // this.changeCurrentPage(0)
      that.PageIndex = 0;
      that.getSalesWarn();
    },
    showWarnInfo () {
      this.showDialogVisible = true;
      this.getSalesWarn();
    },
    // 参数配置按钮打开参数配模态框
    setParams () {
      this.setDialogVisible = true;
    },
    saveEarlyWarningSet (formName) {
      this.isloading = true;
      let that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          let flag = false;
          for (let i = 0; i < that.timeSet.length; i++) {
            let item = that.timeSet[i];
            if (
              item.type == 2 &&
              (item.days == undefined || item.days.length <= 0)
            ) {
              flag = true;
              Message({
                message: "请完善" + item.weekName + "自定义设置",
                type: "error"
              });
              break;
            }
          }
          if (flag) {
            return;
          }
          let data = {
            isAutoWarning: true,
            lowBound: that.ruleForm.lowBound,
            heightBound: that.ruleForm.heightBound,
            timeSet: that.timeSet
          };

          common.earlyWarningSet(data).then(
            res => {
              Message({
                message: "实时预警设置成功",
                type: "success"
              });
              that.isAutoWarning = res.isAutoWarning;
              that.lowBound = res.lowBound;
              that.heightBound = res.heightBound;
              that.timeSet =
                res.timeSet == undefined || res.timeSet.length <= 0
                  ? timeSetOption
                  : that.getTime(res.timeSet);
              that.setDialogVisible = false;
              that.isloading = false;
              if (that.showDialogVisible) {
                that.getSalesWarn();
              }
            },
            err => {
              that.isloading = false;
            }
          );
        } else {
          that.isloading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    getTime (data) {
      return data.map(item => {
        item["weekName"] = weekNames[item.weekDays - 1];
        item["days"] = item.type == 2 ? item.days : [];
        item["visible"] = false;
        return item;
      });
    },
    closeSetDialog () {
      this.setDialogVisible = false;
      this.timeSet = this.timeSet.map(item => {
        item.visible = false;
        return item;
      });
    },
    showDays (val, index) {
      let that = this;
      if (val == 2) {
        that.timeSet = that.timeSet.map((item, index2) => {
          if (index2 == index) {
            item.visible = true; //!item.visible;
          }
          return item;
        });
      } else {
        that.timeSet = that.timeSet.map((item, index2) => {
          if (index2 == index) {
            item.visible = false; //!item.visible;
          }
          return item;
        });
      }
    },
    // 加载分类汇总数据、及分类月明细
    loadSubTotal () {
      let that = this;
      // alert(that.radio)
      // 初始化
      that.modeDelivery = false // 初始化报货模式
      that.tableData1 = [];
      that.tableData2 = [];
      // that.tableData3 = []; // 临时注释20201031
      if (that.radio == 2) {
        that.activeName = "first";
        // if (loading) {
        //   that.$nextTick(() => {
        //     loading.close();
        //   });
        // }
        loading = that.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.7)",
          // target: document.querySelector("#dispatchCenter")
        });
        let DeptId = that.deptValue;
        let SearchDate = that.timeValue;
        if (!DeptId || DeptId.length == 0) {
          that.tableData3 = [];
          that.$nextTick(() => {
            loading.close();
          });
          return;
        }
        let data = {
          searchDate: common.getTime(SearchDate),
          deptId: DeptId.filter(item => item != 'all'),
          searchFlag: that.radioStock,
          productTypeFlag: that.searchFlag // 0显示小类 1显示中类
        };
        common
          .getStockSubtotal(data)
          .then(
            res => {
              that.$nextTick(() => {
                loading.close();
              });
              that.tableData3 = [];
              that.columnSubtotal = []; // 分类汇总数据标题
              let tableSubtotal = [];
              let columnArr = [{
                column: "weekendItem",
                time: "周五至周日(销|存|退)"
              }, {
                column: "weekDayItem",
                time: "周一至周四(销|存|退)"
              }];
              res.map((item, index) => {

                item.weekDayItem["returnAmount"] = common.toDecimal2(item.weekDayItem["returnAmount"])
                item.weekDayItem["salesAmount"] = common.toDecimal2(item.weekDayItem["salesAmount"])
                item.weekDayItem["stockAmount"] = common.toDecimal2(item.weekDayItem["stockAmount"])

                item.weekendItem["returnAmount"] = common.toDecimal2(item.weekendItem["returnAmount"])
                item.weekendItem["salesAmount"] = common.toDecimal2(item.weekendItem["salesAmount"])
                item.weekendItem["stockAmount"] = common.toDecimal2(item.weekendItem["stockAmount"])

                let temp = {
                  productName: item.productTypeName,
                  id: item.productTypeId,
                  weekendItem: item.weekendItem,
                  weekDayItem: item.weekDayItem
                };
                item.items.map((obj, index2) => {
                  let column =
                    index2 == 0 ? "今" : common.getMonthDate(obj.updateDate); //common.getDate(obj.updateDate);
                  if (index == 0) {
                    columnArr = columnArr.concat([
                      {
                        column: column,
                        time:
                          (index2 == 0
                            ? "今"
                            : common.getDate(obj.updateDate)) + "(销|存|退)"
                      }
                    ]);
                  }
                  temp[column] = {
                    salesAmount: common.toDecimal2(obj.salesAmount),
                    stockAmount: common.toDecimal2(obj.stockAmount),
                    returnAmount: common.toDecimal2(obj.returnAmount)
                  };
                });
                tableSubtotal.push(temp);
              });
              that.columnSubtotal = columnArr;
              that.tableData3 = tableSubtotal;
              that.rowclickSubtotal(that.tableData3[0]);

              that.$nextTick(() => {
                that.$refs['summary'].doLayout();
              })
            },
            err => {
              that.$nextTick(() => {
                loading.close();
              });
            }
          )
          .catch(err => {
            that.$nextTick(() => {
              loading.close();
            });
          });
      } else if (that.radio == 1 || that.radio == 4) {
        that.searchProduct()
      } else if (that.radio == 3) {
        // 获取门店报货
        that.getProductTypeDetail()
      }
    },
    // 门店报货
    getProductTypeDetail () {
      let that = this
      let DeptId = that.deptValue;
      let SearchDate = that.timeValue;
      let typeValue = that.typeValue;
      that.tableDataRecord = [] // 清空记录
      loading = that.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
        // target: document.querySelector("#dispatchCenter")
      });
      if (!DeptId || DeptId.length == 0) {
        that.$set(that.formData, "tableData5", [])
        if (loading) {
          that.$nextTick(() => {
            loading.close();
          });
        }
        return;
      }
      if (typeValue.length == 0) {
        that.$set(that.formData, "tableData5", [])
        that.$nextTick(() => {
          loading.close();
        });
        return;
      }
      that.getStockProductType().then(
        res => {
          that.$nextTick(() => {
            loading.close();
          });
          let tableData5 = res.items.map((item, index) => {
            item["index"] = index + 1
            item["lastSalesTime"] = item.lastSalesTime ? common.getTimeDetail(item.lastSalesTime) : null
            item["salesNumFivePer"] = common.toDecimal2(item["salesNumFivePer"]) + "%"
            item["deliveryNum"] = null
            item["deliveryOtherNum"] = null
            return item
          })
          that.totalCount = res.totalCount
          that.$set(that.formData, "tableData5", tableData5)
          that.rowclick(that.formData.tableData5[0], false);
        },
        err => { loading.close(); }
      );
      // /////////////////20201204修改 报货模式单独接口查询 start//////////////////////
      // let data = {
      //   deptId: DeptId.filter(item => item != 'all'),
      //   productTypeId1: that.productTypeId1.filter(item => item != 'all'), // 中类
      //   productTypeId: typeValue.filter(item => item != 'all'), // 小类
      //   stockDate: common.getTime(SearchDate),
      //   productTypeFlag: that.searchFlag, // 0小类 1中类
      //   deliveryDate: that.deliveryDate,
      //   timeFlag: that.timeFiveValue == '17:00' ? 0 : 1, // 0查询五点后数据  1查询3点后数据
      //   isRequest: that.modeDelivery ? 1 : 0, // 0非报货模式  1报货模式
      //   pageIndex: that.pageIndex2,    // 报货模式分页
      //   pageSize: that.pageSize2
      // }
      // stockApi.getProductTypeDetail(data).then(
      //   res => {
      //     that.$nextTick(() => {
      //       loading.close();
      //     });
      //     let tableData5 = res.items.map((item, index) => {
      //       item["index"] = index + 1
      //       item["lastSalesTime"] = item.lastSalesTime ? common.getTimeDetail(item.lastSalesTime) : null
      //       item["salesNumFivePer"] = common.toDecimal2(item["salesNumFivePer"]) + "%"
      //       item["deliveryNum"] = null
      //       item["deliveryOtherNum"] = null
      //       return item
      //     })
      //     that.totalCount = res.totalCount
      //     that.$set(that.formData, "tableData5", tableData5)
      //     that.rowclick(that.formData.tableData5[0], false);
      //   },
      //   err => { loading.close(); }
      // );
      // /////////////////20201204修改 报货模式单独接口查询 end//////////////////////
    },
    // 报货模板显示列表数据
    getStockProductType () {
      return new Promise((resolve, reject) => {
        let that = this
        let DeptId = that.deptValue;
        let SearchDate = that.timeValue;
        let typeValue = that.typeValue;
        let data = {
          deptId: DeptId.filter(item => item != 'all'),
          stockDate: common.getTime(SearchDate),
          productTypeFlag: that.searchFlag, // 0小类 1中类
          deliveryDate: that.deliveryDate,
          timeFlag: that.timeFiveValue == '17:00' ? 0 : 1, // 0查询五点后数据  1查询3点后数据
        }
        if (that.modeDelivery) {
          let arr = that.templateId.split('&&')
          // 报货模式
          data["templateId"] = arr[0]
          stockApi
            .getStockProductTypeRequestDetail(data)
            .then(res => {
              resolve(res);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          // 非报货模式
          data["productTypeId1"] = that.productTypeId1.filter(item => item != 'all') // 中类
          data["productTypeId"] = typeValue.filter(item => item != 'all') // 小类
          data["isRequest"] = that.modeDelivery ? 1 : 0 // 0非报货模式  1报货模式
          data["pageIndex"] = that.pageIndex2 // 报货模式分页
          data["pageSize"] = that.pageSize2
          stockApi
            .getProductTypeDetail(data)
            .then(res => {
              resolve(res);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // 暂不使用 start
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 3) {
        if (columnIndex >= 1) {
          return [1, 33];
        }
      }
    },
    // 暂不使用 end
    // 切换区域，根据区域获取门店
    changeArea (val) {
      let that = this
      const allValues = [];
      for (const item of that.deptAreaOptions) {
        allValues.push(item.id);
      }
      const oldVal =
        that.oldDeptArea.length === 1 ? that.oldDeptArea[0] : [];
      if (val.includes("all")) that.areaValue = allValues
      if (oldVal.includes("all") && !val.includes("all"))
        that.areaValue = []
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.areaValue = val
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        if (val.length === allValues.length - 1)
          that.areaValue = ["all"].concat(val)
      }
      that.oldDeptArea[0] = that.areaValue;

      if (that.areaValue.length == 0) {
        that.deptValue = [] // 门店
        that.typeValue = [] // 小类
        that.deptOptions = [] // 门店
        that.typeOptions = [] // 小类
        that.oldSearchDeptType = [] // 门店
        that.oldProductType = [] // 小类
      } else {
        let data = { AreaId: that.areaValue[0] === 'all' ? [] : that.areaValue }
        that.getDept(data).then(
          res => {
            that.deptOptions = [{ deptId: "all", deptName: "全选" }].concat(res)
            that.deptValue = []
            // that.deptOptions.map(item => {
            //   return item.deptId
            // })
            that.oldSearchDeptType = []//['all'] // 门店
          },
          err => {
            console.log(err)
          }
        )
      }
    },
    // 当时间和门店发生变化时：重新查找分类\营业额等
    searchContent (val, flag = false) {
      let that = this;
      that.modeDelivery = false // 初始化报货模式
      const allValues = [];
      for (const item of that.deptOptions) {
        allValues.push(item.deptId);
      }
      if (!flag) {
        const oldVal =
          that.oldSearchDeptType.length === 1 ? that.oldSearchDeptType[0] : [];
        if (val.includes("all")) that.deptValue = allValues;
        if (oldVal.includes("all") && !val.includes("all")) that.deptValue = [];
        if (oldVal.includes("all") && val.includes("all")) {
          const index = val.indexOf("all");
          val.splice(index, 1); // 排除全选选项
          that.deptValue = val;
        }
        if (!oldVal.includes("all") && !val.includes("all")) {
          console.log(11);
          if (val.length === allValues.length - 1)
            that.deptValue = ["all"].concat(val);
        }
      }
      that.oldSearchDeptType[0] = that.deptValue;
      if (that.deptValue.length == 0) {
        that.typeValue = [] // 小类
        that.typeOptions = [] // 小类
        that.oldProductType = [] // 小类
        that.typeList1 = [] // 中类
        that.productTypeId1 = [] // 中类
        that.oldProductType1 = [] // 中类
      } else {
        that.typeValue = []; // 小类
        that.typeOptions = [] // 小类
        that.oldProductType = [] // 小类
        that.productTypeId1 = [] // 中类
        that.oldProductType1 = [] // 中类
        let DeptId = that.deptValue;
        let SearchDate = that.timeValue;
        if (!DeptId || DeptId.length == 0) {
          return;
        }
        if (!SearchDate) {
          return;
        }
        let data = {
          typeFlag: 1,
          deptId: DeptId.filter(item => item != 'all'),
          beginDate: common.getStartTime(SearchDate),
          endDate: common.getEndTime(SearchDate)
        };
        common.getProductTypeListByFLag(data).then(
          res => {
            that.typeList1 = [{ productTypeId: "all", productTypeName: "全选" }].concat(res);
          },
          err => { }
        );
        that.getSales();
        that.getStock();
        that.currentTime = common.getTime(that.timeValue);
        that.loadSubTotal();
      }
    },
    drawLine () {
      let that = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = that.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        color: ["#f1bc4c", "#4c9aef"],
        // graphic: {
        //   type: "text",
        //   left: "center",
        //   top: "center",
        //   style: {
        //     text: "今日总货量\n￥" + that.totalMoney,
        //     textAlign: "center",
        //     fill: "#000",
        //     width: 30,
        //     height: 30,
        //     fontSize: "14"
        //   }
        // },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["45%", "80%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(255, 255, 255, 0.2)",
                textColor: "#000"
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: that.lastMoneyPer, name: "昨日剩货" },
              {
                value: that.inMoneyPer, //inMoney,
                name: "今日到货"
              }
            ]
          },
          // 边框的设置
          {
            radius: ["70%", "80%"],
            center: ["50%", "50%"],
            type: "pie",
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            animation: false,
            tooltip: {
              show: false
            },
            itemStyle: {
              normal: {
                color: "rgba(250,250,250,0.2)"
              }
            },
            data: [
              {
                value: 1
              }
            ]
          }
        ]
      });
    },
    drawLine2 () {
      // console.log("drawLine2");
      let that = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = that.$echarts.init(document.getElementById("myChart2"));
      let nowLastMoneyPer = that.nowLastMoneyPer;
      let per = that.nowLastMoneyPer / 100;
      // 绘制图表
      myChart.setOption({
        series: [
          {
            type: "liquidFill",
            radius: "80%",
            data: [per],
            color: ["rgba(76,154,239,1)"],
            label: {
              normal: {
                color: "#fff",
                insideColor: "transparent",
                textStyle: {
                  fontSize: 16,
                  fontWeight: "bold",
                  fontFamily: "Microsoft YaHei"
                },
                formatter: function (param) {
                  return nowLastMoneyPer + "%";
                }
              }
            },
            outline: {
              show: true,
              borderDistance: 5,
              itemStyle: {
                borderColor: "rgba(81,156,239,1)",
                borderWidth: 2
              }
            },
            backgroundStyle: {
              color: "rgba(76,154,239,0.5)"
            },
            itemStyle: {
              // opacity: 0.5, //波浪的透明度
              shadowBlur: 0 //波浪的阴影范围
              // shadowColor: "#fff" //阴影颜色
            }
          }
        ]
      });
    },
    drawLine3 (data1, data2, data3, data4, data5) {
      let that = this;
      let arr = [];
      let t = 1
      if (that.valueTimes == 30) {
        t = 0.5
      }
      for (let i = 6; i <= 24; i += t) {
        arr.push(i + ""); //属性
      }
      // 基于准备好的dom，初始化echarts实例
      let myChart = that.$echarts.init(document.getElementById("myChart3"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          formatter: function (params, ticket, callback) {
            let str = params[0].name += '<br/>'
            for (var i = 0, l = params.length; i < l; i++) {
              str += ('<div style="display:flex;padding-right:8px;"><div style="width:90px;text-align: right;padding-right:8px;">' + params[i].marker + params[i].seriesName + " : </div><div>" + (params[i].data != null ? params[i].data : '') + '</div></div>');
            }
            return str
          }
        },
        legend: {
          y: 25,
          itemGap: 100,
          itemWidth: 25,
          data: ["库存", "销量", "上周销量", "上月销量", "去年销量"]
          // selected: { 去年销售: false }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: arr.map(item => item)
        },
        yAxis: {
          type: "value"
        },
        color: ["#e526ec", "#f27233", "#79f554", "#4696d5", "#DAA520"],
        series: [
          {
            name: "库存",
            type: "line",
            data: data1,
            symbolSize: 6, //拐点圆的大小
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          },
          {
            name: "销量",
            type: "line",
            data: data2,
            symbolSize: 6, //拐点圆的大小
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          },
          {
            name: "上周销量",
            type: "line",
            data: data3,
            symbolSize: 6, //拐点圆的大小
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          },
          {
            name: "上月销量",
            type: "line",
            data: data5,
            symbolSize: 6, //拐点圆的大小
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          },
          {
            name: "去年销量",
            type: "line",
            data: data4,
            symbolSize: 6, //拐点圆的大小
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          }
        ]
      });
    },
    drawLine4 () {
      let that = this;
      let dataMonthLy1 = that.dataMonthLy1;
      let dataMonthLy2 = that.dataMonthLy2;
      let dataMonthLy3 = that.dataMonthLy3;
      let dataMonthLy4 = that.dataMonthLy4;
      let dataMonthLy5 = that.dataMonthLy5;
      let dataArrMonthLy = that.dataArrMonthLy;
      // alert(JSON.stringify(data3) + "----" + JSON.stringify(data4));
      // 基于准备好的dom，初始化echarts实例
      let myChart = that.$echarts.init(document.getElementById("myChart4"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          formatter: function (params, ticket, callback) {
            let str = params[0].name += '<br/>'
            for (var i = 0, l = params.length; i < l; i++) {
              str += ('<div style="display:flex;padding-right:8px;"><div style="width:100px;text-align: right;padding-right:8px;">' + params[i].marker + params[i].seriesName + " : </div><div>" + (params[i].data != null ? params[i].data : '') + '</div></div>');
            }
            return str
          }
        },
        legend: {
          y: 25,
          itemGap: 100,
          itemWidth: 25,
          data: ["销量", (this.timeFiveValue == '17:00' ? '5' : '3') + "点后(占比)", "库存", "退货", "平均销量"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          // boundaryGap: false,
          data: dataArrMonthLy
        },
        yAxis: {
          type: "value"
        },
        color: ["#e526ec", "#f27233", "#79f554", "#4696d5", "#DAA520"],
        // color: ["#fb9e5b", "#4e9bed", "#afa3f5", "#d65e5b"],
        series: [
          {
            name: "销量",
            type: "line",
            data: dataMonthLy1,
            symbolSize: 6, //拐点圆的大小
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          },
          {
            name: (this.timeFiveValue == '17:00' ? '5' : '3') + "点后(占比)",
            type: "line",
            data: dataMonthLy5,
            symbolSize: 6, //拐点圆的大小
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          },
          {
            name: "库存",
            type: "line",
            data: dataMonthLy2,
            symbolSize: 6, //拐点圆的大小
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          },
          {
            name: "退货",
            type: "line",
            data: dataMonthLy3,
            symbolSize: 6, //拐点圆的大小
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          },
          {
            name: "平均销量",
            type: "line",
            data: dataMonthLy4,
            symbolSize: 6, //拐点圆的大小
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2.5
                }
              }
            }
          }
        ]
      });
    },
    // myChart4
    drawLine5 () {
      return new Promise((resolve, reject) => {
        //销售
        let that = this;

        let dataTypeMonthLy1 = that.dataTypeMonthLy1;
        let dataTypeMonthLy2 = that.dataTypeMonthLy2;
        let dataTypeMonthLy3 = that.dataTypeMonthLy3;
        let dataTypeMonthLy4 = that.dataTypeMonthLy4;
        let dataTypeMonthLy5 = that.dataTypeMonthLy5;
        let dataTypeArrMonthLy = that.dataTypeArrMonthLy;
        // 基于准备好的dom，初始化echarts实例
        let myChart = that.$echarts.init(document.getElementById("myChart5"));
        // 绘制图表
        myChart.setOption({
          tooltip: {
            trigger: "axis",
            formatter: function (params, ticket, callback) {
              let str = params[0].name += '<br/>'
              for (var i = 0, l = params.length; i < l; i++) {
                str += ('<div style="display:flex;padding-right:8px;"><div style="width:100px;text-align: right;padding-right:8px;">' + params[i].marker + params[i].seriesName + " : </div><div>" + (params[i].data != null ? params[i].data : '') + '</div></div>');
              }
              return str
            }
          },
          legend: {
            y: 25,
            itemGap: 100,
            itemWidth: 25,
            data: ["销售", (this.timeFiveValue == '17:00' ? '5' : '3') + "点后(占比)", "库存", "退货", "平均销售"]
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: dataTypeArrMonthLy
          },
          yAxis: {
            type: "value"
          },
          color: ["#e526ec", "#f27233", "#79f554", "#4696d5", "#DAA520"],
          series: [
            {
              name: "销售",
              type: "line",
              data: dataTypeMonthLy1,
              symbolSize: 6, //拐点圆的大小
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 2.5
                  }
                }
              }
            },
            {
              name: (this.timeFiveValue == '17:00' ? '5' : '3') + "点后(占比)",
              type: "line",
              data: dataTypeMonthLy5,
              symbolSize: 6, //拐点圆的大小
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 2.5
                  }
                }
              }
            },
            {
              name: "库存",
              type: "line",
              data: dataTypeMonthLy2,
              symbolSize: 6, //拐点圆的大小
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 2.5
                  }
                }
              }
            },
            {
              name: "退货",
              type: "line",
              data: dataTypeMonthLy3,
              symbolSize: 6, //拐点圆的大小
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 2.5
                  }
                }
              }
            },
            {
              name: "平均销售",
              type: "line",
              data: dataTypeMonthLy4,
              symbolSize: 6, //拐点圆的大小
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 2.5
                  }
                }
              }
            }
          ]
        });
        resolve(true);
      });
    },

    tableRowClassName ({ row, rowIndex }) {
      // console.log("tableRowClassName");
      if (rowIndex % 2 === 0) {
      } else {
        return "success-row";
      }
      return "";
    },

    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 指定列号
        return "color:#4e9bed";
      } else {
        return "";
      }
    },
    // 获取部门
    getDept (data) {
      return new Promise((resolve, reject) => {
        deptApi
          .getDept(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取区域
    getDeptArea () {
      return new Promise((resolve, reject) => {
        deptApi
          .getDeptArea()
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //营业额，客单数，客单价，上班人数
    getSales () {
      let that = this;
      let DeptId = that.deptValue;
      let SearchDate = that.timeValue;
      if (!DeptId || DeptId.length == 0) {
        return;
      }
      if (!SearchDate) {
        return;
      }
      let data = {
        DeptId: DeptId.filter(item => item != 'all'),
        SearchDate: common.getTime(SearchDate)
      };
      salesApi.getSales(data).then(
        res => {
          that.salesMoney = res.salesMoney; //营业额（元）
          that.salesCount = res.salesCount; //客单数（笔）
          that.salesPrice = res.salesPrice; //客单价（元）
          that.workNum = res.workNum; // 上班人数
          that.salesMoneyLast = res.salesMoneyLast;
          that.salesCountLast = res.salesCountLast;
          that.salesPriceLast = res.salesPriceLast;
          that.workNumLast = res.workNumLast;

          that.salesMoneyLastYear = res.salesMoneyLastYear;
          that.salesCountLastYear = res.salesCountLastYear;
          that.salesPriceLastYear = res.salesPriceLastYear;
          that.workNumLastYear = res.workNumLastYear;
        },
        err => { }
      );
    },

    //出货剩货
    getStock () {
      let that = this;
      let DeptId = that.deptValue;
      let SearchDate = that.timeValue;
      if (!DeptId || DeptId.length == 0) {
        return;
      }
      if (!SearchDate) {
        return;
      }
      let data = {
        DeptId: DeptId.filter(item => item != 'all'),
        SearchDate: common.getTime(SearchDate)
      };
      stockApi.getStock(data).then(
        res => {
          that.inMoney = Math.round(res.inMoney * 100) / 100; // 今日到货
          that.lastMoney = Math.round(res.lastMoney * 100) / 100; // 昨日剩货

          that.totalMoney =
            Math.round((res.inMoney + res.lastMoney) * 100) / 100; // 今日总货量
          that.inMoneyPer =
            Math.round(
              (that.totalMoney ? (that.inMoney / that.totalMoney) * 100 : 100) *
              100
            ) / 100; // 今日到货占比
          that.lastMoneyPer = Math.round((100 - that.inMoneyPer) * 100) / 100; // 昨日剩货占比
          that.nowLastMoney =
            Math.round((res.inMoney + res.lastMoney - res.outMoney) * 100) /
            100; // 剩货
          that.nowLastMoneyPer =
            Math.round(
              (that.totalMoney
                ? (that.nowLastMoney / that.totalMoney) * 100
                : 100) * 100
            ) / 100; // 剩货占比
          that.drawLine();
          that.drawLine2();
        },
        err => { }
      );
    },
    // 分类汇总获取顶部折线图和表
    rowclickSubtotal (row) {
      this.loading2 = true;
      let that = this;
      let radioStock = that.radioStock
      let DeptId = that.deptValue;
      let SearchDate = that.timeValue;
      if (!DeptId || DeptId.length == 0 || typeof row === 'undefined' || !row || row.length == 0) {
        that.tableData3 = [];
        that.loading2 = false;
        return;
      }
      that.currRow = row
      let data = {
        searchDate: common.getTime(SearchDate),
        deptId: DeptId.filter(item => item != 'all'),
        productTypeId: row.id,
        searchFlag: radioStock,
        productTypeFlag: that.searchFlag, // 0小类 1中类
        timeFlag: that.timeFiveValue == '17:00' ? 0 : 1 // 0查询五点后数据  1查询3点后数据
      };
      common
        .getStockTypeMonthLy(data)
        .then(
          res => {
            that.handleCurrentChange(row);
            that.currentProductTypeName = row.productName;
            // res.items; //循环获取表头、数据
            that.columnTypeMonthLy = [];
            that.tableDataTypeMonthLy = [];
            let columnArr = [{ column: "name", day: "" }];
            columnArr.push({
              column: 'weekendItem',
              time: '周五至周日',
              day: common.getDay(res.weekendItem.updateDate) + ""
            });
            columnArr.push({
              column: 'weekDayItem',
              time: '周一至周四',
              day: common.getDay(res.weekDayItem.updateDate) + ""
            });
            let salesAmountArr = { name: "销售" };
            let salesNumFivePerentArr = { name: (this.timeFiveValue == '17:00' ? '5' : '3') + "点后(占比)" };
            let stockAmountArr = { name: "库存" };
            let returnAmountArr = { name: "退货" };
            // let averSalesAmountArr = { name: "平均销售" };
            let lastSalesDateArr = { name: "末笔" };
            let dataTypeMonthLy1 = [];
            let dataTypeMonthLy2 = [];
            let dataTypeMonthLy3 = [];
            let dataTypeMonthLy4 = [];
            let dataTypeArrMonthLy = [];
            that.dataTypeArrMonthLy = ['周五至周日', '周一至周四'];
            that.dataTypeMonthLy1 = [];
            that.dataTypeMonthLy2 = [];
            that.dataTypeMonthLy3 = [];
            that.dataTypeMonthLy4 = [];
            that.dataTypeMonthLy5 = [];
            that.averSalesAmount = res.averSalesAmount; //平均销售
            res.items.map((item, index) => {
              let column = common.getMonthDate(item.updateDate) + "";
              columnArr.push({
                column: column,
                time: common.getDate(item.updateDate),
                day: common.getDay(item.updateDate) + ""
              });
              that.dataTypeArrMonthLy.push(common.getDate(item.updateDate));
              salesAmountArr[column] = item.salesAmount;
              that.dataTypeMonthLy1.push(item.salesAmount);
              stockAmountArr[column] = item.stockAmount;
              that.dataTypeMonthLy2.push(item.stockAmount);
              returnAmountArr[column] = item.returnAmount;
              that.dataTypeMonthLy3.push(item.returnAmount);
              // 5\3点后占比
              salesNumFivePerentArr[column] = parseFloat(item.salesNumFive) + "(" + parseFloat(common.toDecimal2(item.salesNumFivePercent + "")) + '%)'; // 5\3点后（占比）
              that.dataTypeMonthLy5.push(item.salesNumFive);
              that.dataTypeMonthLy4.push(res.averSalesAmount);
              lastSalesDateArr[column] = common.getTimeDetail(
                item.lastSalesDate
              );
            });
            // 周五至周日、周一至周四数据表头填充 start

            salesAmountArr['weekendItem'] = common.toDecimal2(res.weekendItem.salesAmount);
            salesNumFivePerentArr['weekendItem'] = parseFloat(common.toDecimal2(res.weekendItem.salesNumFive)) + "(" + parseFloat(common.toDecimal2(res.weekendItem.salesNumFivePercent + "")) + '%)';
            stockAmountArr['weekendItem'] = common.toDecimal2(res.weekendItem.stockAmount);
            returnAmountArr['weekendItem'] = common.toDecimal2(res.weekendItem.returnAmount);
            lastSalesDateArr['weekendItem'] = res.weekendItem.lastSalesDate ? common.getTimeDetail(res.weekendItem.lastSalesDate) : ""
            that.dataTypeMonthLy4.push(common.toDecimal2(res.averSalesAmount));
            that.dataTypeMonthLy5.push(common.toDecimal2(res.weekendItem.salesNumFive));

            salesAmountArr['weekDayItem'] = common.toDecimal2(res.weekDayItem.salesAmount);
            salesNumFivePerentArr['weekDayItem'] = parseFloat(common.toDecimal2(res.weekDayItem.salesNumFive)) + "(" + parseFloat(common.toDecimal2(res.weekDayItem.salesNumFivePercent + "")) + '%)';
            stockAmountArr['weekDayItem'] = common.toDecimal2(res.weekDayItem.stockAmount);
            returnAmountArr['weekDayItem'] = common.toDecimal2(res.weekDayItem.returnAmount);
            lastSalesDateArr['weekDayItem'] = res.weekDayItem.lastSalesDate ? common.getTimeDetail(res.weekDayItem.lastSalesDate) : ""
            that.dataTypeMonthLy4.push(common.toDecimal2(res.averSalesAmount));
            that.dataTypeMonthLy5.push(common.toDecimal2(res.weekDayItem.salesNumFive));
            // 周五至周日、周一至周四数据表头填充 end
            that.dataTypeMonthLy1 = [common.toDecimal2(res.weekDayItem.salesAmount)].concat(that.dataTypeMonthLy1);
            that.dataTypeMonthLy2 = [common.toDecimal2(res.weekDayItem.stockAmount)].concat(that.dataTypeMonthLy2);
            that.dataTypeMonthLy3 = [common.toDecimal2(res.weekDayItem.returnAmount)].concat(that.dataTypeMonthLy3);
            that.dataTypeMonthLy5 = [common.toDecimal2(res.weekDayItem.salesNumFive)].concat(that.dataTypeMonthLy5);

            that.dataTypeMonthLy1 = [common.toDecimal2(res.weekendItem.salesAmount)].concat(that.dataTypeMonthLy1);
            that.dataTypeMonthLy2 = [common.toDecimal2(res.weekendItem.stockAmount)].concat(that.dataTypeMonthLy2);
            that.dataTypeMonthLy3 = [common.toDecimal2(res.weekendItem.returnAmount)].concat(that.dataTypeMonthLy3);
            that.dataTypeMonthLy5 = [common.toDecimal2(res.weekendItem.returnAmount)].concat(that.dataTypeMonthLy5);

            that.columnTypeMonthLy = columnArr;  // 表头
            that.tableDataTypeMonthLy.push(salesAmountArr);
            that.tableDataTypeMonthLy.push(salesNumFivePerentArr); // 5\3点后（占比）数据
            that.tableDataTypeMonthLy.push(stockAmountArr);
            that.tableDataTypeMonthLy.push(returnAmountArr);
            that.tableDataTypeMonthLy.push(lastSalesDateArr);
            that.drawLine5().then(res => {
              that.loading2 = false;
            });
            that.loading2 = false;
          },
          err => {
            that.loading2 = false;
          }
        )
        .catch(err => {
          that.loading2 = false;
        });
    },
    stopclick () {
      // alert("stop") 
    },
    // 点击时间段行变换折线图等
    rowclick (row, flag = true) {
      // console.log("rowclick");
      let that = this;
      // if (loading) {
      //   that.$nextTick(() => {
      //     loading.close();
      //   });
      // }
      // if (flag) {
      //   loading = that.$loading({
      //     lock: true,
      //     text: "拼命加载中",
      //     spinner: "el-icon-loading",
      //     background: "rgba(255, 255, 255, 0.7)",
      //     // target: document.querySelector("#dataDetail1")
      //   });
      // }
      // alert(JSON.stringify(row));
      that.handleCurrentChange(row);
      let radio = that.radio;
      that.currentProductName = row.productName;
      that.getProductDetail(row.productId, row.productName);
      that.getStockDept(row.productId);
      that.getSalesDetail(row.productId);
      that.getStockMonthLy(row.productId);
      if (radio == 4) {
        that.data1 = that.getData(row); // 库存
        let data = that.tableData2.filter(
          item => item.productId == row.productId
        )[0]; // 销量中获取
        that.data2 = that.getData(data); // 销量
        that.data3 = data["arrWeek"];
        that.data4 = data["arrYear"];
        that.data5 = data["arrMonth"];
        that.drawLine3(that.data1, that.data2, that.data3, that.data4, that.data5);
      } else if (radio == 1) {
        that.data2 = that.getData(row);
        that.data3 = row["arrWeek"];
        that.data4 = row["arrYear"];
        that.data5 = row["arrMonth"];
        that.data1 = that.getData(
          that.tableData1.filter(item => item.productId == row.productId)[0]
        );
        that.drawLine3(that.data1, that.data2, that.data3, that.data4, that.data5);
      } else if (radio == 3) {
        // 门店报货 获取折线图数据
        // that.getProductRealTime(row.productId).then(res => {
        //   let h = new Date().getHours();
        //   let result = that.getResult([res], h);
        //   that.data1 = []//that.getData(result[0]); // 库存
        //   that.data2 = that.getData(result[0]);//that.getData(result); // 销量
        //   that.data3 = result[0]["arrWeek"];
        //   that.data4 = result[0]["arrYear"];
        //   that.data5 = result[0]["arrMonth"];
        //   that.drawLine3(that.data1, that.data2, that.data3, that.data4, that.data5);
        // }, err => {
        //   console.log(err)
        // })
        Promise.all([
          that.getProductRealTime(row.productId),
          that.getStockProductRealTime(row.productId)
        ])
          .then(
            res => {
              // loading.close();
              let h = new Date().getHours();
              let result = that.getResult([res[0]], h);
              let result2 = that.getResult([res[1]], h) // 库存
              that.data1 = that.getData(result2[0]) // 库存
              that.data2 = that.getData(result[0]);// 销量
              that.data3 = result[0]["arrWeek"];
              that.data4 = result[0]["arrYear"];
              that.data5 = result[0]["arrMonth"];
              that.drawLine3(that.data1, that.data2, that.data3, that.data4, that.data5);
            },
            err => {
              // loading.close();
            }
          )
          .catch(error => {
            // that.$nextTick(() => {
            //   loading.close();
            // });
          });
      }
      // that.drawLine3(that.data1, that.data2, that.data3, that.data4, that.data5);
      // that.$nextTick(() => {
      //   loading.close();
      // });
    },
    // 单品库存
    getStockProductRealTime (productId) {
      let that = this
      let DeptId = that.deptValue;
      let SearchDate = that.timeValue;
      if (!DeptId || DeptId.length == 0) {
        return;
      }
      if (!SearchDate) {
        return;
      }
      let data = {
        deptId: DeptId.filter(item => item != 'all'),
        searchDate: common.getTime(SearchDate),
        productId: productId
      }
      return new Promise((resolve, reject) => {
        stockApi
          .getStockProductRealTime(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 单品销量
    getProductRealTime (productId) {
      let that = this
      let DeptId = that.deptValue;
      let SearchDate = that.timeValue;
      if (!DeptId || DeptId.length == 0) {
        return;
      }
      if (!SearchDate) {
        return;
      }
      let data = {
        deptId: DeptId.filter(item => item != 'all'),
        searchDate: common.getTime(SearchDate),
        productId: productId
      }
      return new Promise((resolve, reject) => {
        salesApi
          .getProductRealTime(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    rowclickSalesDetail (row) {
      let that = this;
      let SearchDate = that.timeValue;
      let data = {
        Id: row.id,
        SalesDate: row.salesDate
      };
      salesApi.getSalesProductDetail(data).then(
        res => {
          that.tableDataSalesProduct = res;
        },
        err => { }
      );
    },
    handleCurrentChange (val) {
      this.currentRow = val;
    },
    // 切换中类 重新请求数据
    changeProductType1 (val) {
      let that = this
      that.modeDelivery = false // 初始化报货模式
      const allValues = [];
      for (const item of that.typeList1) {
        allValues.push(item.productTypeId);
      }
      const oldVal =
        that.oldProductType1.length === 1 ? that.oldProductType1[0] : [];
      if (val.includes("all")) that.productTypeId1 = allValues
      if (oldVal.includes("all") && !val.includes("all"))
        that.productTypeId1 = []
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.productTypeId1 = val
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        if (val.length === allValues.length - 1)
          that.productTypeId1 = ["all"].concat(val)
      }
      that.oldProductType1[0] = that.productTypeId1;
      if (that.productTypeId1.length == 0) {
        that.typeValue = [] // 小类
        that.typeOptions = [] // 小类
        that.oldProductType = [] // 小类
      } else {
        that.typeValue = [] // 小类
        that.oldProductType = [] // 小类
        let DeptId = that.deptValue;
        let SearchDate = that.timeValue;
        if (!DeptId || DeptId.length == 0) {
          return;
        }
        if (!SearchDate) {
          return;
        }
        let data = {
          typeFlag: 0,
          deptId: DeptId.filter(item => item != 'all'),
          beginDate: common.getStartTime(SearchDate),
          endDate: common.getEndTime(SearchDate)
        }
        if (that.productTypeId1[0] !== 'all') { data["typeId"] = that.productTypeId1 }
        common.getProductTypeListByFLag(data).then(
          res => {
            that.typeOptions = [{ productTypeId: "all", productTypeName: "全选" }].concat(res)
          },
          err => {
            console.log(err)
          }
        )
      }
    },
    // 当分类发生变化
    changeProductType (val) {
      let that = this
      that.modeDelivery = false // 初始化报货模式
      const allValues = [];
      for (const item of that.typeOptions) {
        allValues.push(item.productTypeId);
      }
      const oldVal =
        that.oldProductType.length === 1 ? that.oldProductType[0] : [];
      if (val.includes("all")) that.typeValue = allValues
      if (oldVal.includes("all") && !val.includes("all"))
        that.typeValue = []
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.typeValue = val
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        if (val.length === allValues.length - 1)
          that.typeValue = ["all"].concat(val)
      }
      that.oldProductType[0] = that.typeValue;
      if (that.radio == 1 || that.radio == 4) {
        that.searchProduct()
      } else if (that.radio == 3) {
        // 获取门店报货
        that.getProductTypeDetail()
      }
    },
    // 当分类发生变化
    searchProduct () {
      let that = this;
      let DeptId = that.deptValue;
      let SearchDate = that.timeValue;
      let typeValue = that.typeValue;
      if (loading) {
        that.$nextTick(() => {
          loading.close();
        });
      }
      loading = that.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
        // target: document.querySelector("#search-content-h")
      });
      if (!DeptId || DeptId.length == 0) {
        that.tableData1 = [];
        that.tableData2 = [];
        if (loading) {
          that.$nextTick(() => {
            loading.close();
          });
        }
        return;
      }
      if (typeValue.length == 0) {
        that.tableData1 = [];
        that.tableData2 = [];
        that.$nextTick(() => {
          loading.close();
        });
        return;
      }
      let data = {
        DeptId: DeptId.filter(item => item != 'all'), //"08EDC55C48B44CB5AC004D8C35339526",
        SearchDate: common.getTime(SearchDate),
        ProductTypeIds: typeValue.filter(item => item != 'all')
      };
      let radio = that.radio;
      Promise.all([that.getRealTimeStock(data), that.getRealTimeSales(data)])
        .then(
          res => {
            that.$nextTick(() => {
              loading.close();
            });
            let h = new Date().getHours();
            // Vue.set(that.tableData1, 0, that.getResult(res[0], h))
            // Vue.set(that.tableData2, 0, that.getResult(res[1], h))
            that.tableData1 = that.getResult(res[0], h);
            that.tableData2 = that.getResult(res[1], h);
            that.rowclick(
              radio == 4 ? that.tableData1[0] : that.tableData2[0], false
            );
          },
          err => {
            that.$nextTick(() => {
              loading.close();
            });
          }
        )
        .catch(err => {
          that.$nextTick(() => {
            loading.close();
          });
        });
    },
    getData (data) {
      let arr = [];
      if (typeof data != "undefined") {
        let t = 1
        if (this.valueTimes == 30) {
          t = 0.5
        }
        for (let i = 6; i <= 24; i += t) {
          let key = Number.isInteger(i) ? i.toString() : Number.parseInt(i) + '&5'
          arr.push(data[key]); //属性
        }
      }
      return arr;
    },
    getResult (data, h) {
      let that = this;
      let timeValue = common.getTime(that.timeValue);
      return data.map((value, key, arr) => {
        let temp = {};
        temp["index"] = key+1;
        temp["productId"] = value["productId"];
        temp["productName"] = value["productName"];
        temp["salesABC"] = value["salesABC"];
        temp["profitABC"] = value["profitABC"];
        temp["sumABC"] = value["sumABC"];
        temp["productCode"] = value["productCode"];
        let items = value["items"];
        let itemsLastWeek = value["itemsLastWeek"] || [];
        let itemsLastMonth = value["itemsLastMonth"] || [];
        let itemsLastYear = value["itemsLastYear"] || [];
        let num = 0;
        let arrWeek = [];
        let numWeek = 0;
        let arrMonth = [];
        let numMonth = 0;
        let arrYear = [];
        let numYear = 0;
        for (let i = 6; i <= 24; i += 0.5) {
          let key = Number.isInteger(i) ? i.toString() : Number.parseInt(i) + '&5'
          temp[key] = 0;
          for (let item of items) {
            if (i.toString() == item.time.toString()) {
              num = num + item.num;
            }
          }
          for (let item of itemsLastWeek) {
            if (i.toString() == item.time.toString()) {
              numWeek = numWeek + item.num;
            }
          }
          for (let item of itemsLastMonth) {
            if (i.toString() == item.time.toString()) {
              numMonth = numMonth + item.num;
            }
          }
          for (let item of itemsLastYear) {
            if (i.toString() == item.time.toString()) {
              numYear = numYear + item.num;
            }
          }
          var timestamp1 = new Date(timeValue).getTime();
          // 根据毫秒数构建 Date 对象
          var DateGL1 = new Date(timestamp1);
          var timestamp2 = new Date(common.getTime(new Date())).getTime();
          // 根据毫秒数构建 Date 对象
          var DateGL2 = new Date(timestamp2);
          // temp[i.toString()] =
          //   timeValue >= common.getTime(new Date()) && i > h ? null : num;
          temp[key] = DateGL1 >= DateGL2 && i > h ? null : num;
          arrWeek.push(numWeek);
          arrMonth.push(numMonth)
          arrYear.push(numYear);
        }
        temp["arrWeek"] = arrWeek;
        temp["arrMonth"] = arrMonth;
        temp["arrYear"] = arrYear;
        return temp;
      });
      //return result;
    },
    //时间段销售
    getRealTimeSales (data) {
      //console.log("getRealTimeSales");
      return new Promise((resolve, reject) => {
        //销售
        salesApi
          .getRealTimeSales(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getRealTimeStock (data) {
      //console.log("getRealTimeStock");
      return new Promise((resolve, reject) => {
        // 库存
        stockApi
          .getRealTimeStock(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //门店报货
    getProductDetail (ProductId, productName) {
      //console.log("getProductDetail");
      let that = this;
      let DeptId = that.deptValue;
      let SearchDate = that.timeValue;
      let data = {
        DeptId: DeptId.filter(item => item != 'all'),
        StockDate: common.getTime(SearchDate),
        ProductId: ProductId
      };
      stockApi.getProductDetail(data).then(
        res => {
          res["productName"] = productName;
          res["lastSalesTime"] = res.lastSalesTime ? common.getTimeDetail(res.lastSalesTime) : null;
          that.tableDataStock = [res];
        },
        err => { }
      );
    },
    // 各门店库存
    getStockDept (ProductId) {
      //console.log("getStockDept");
      let that = this;
      let SearchDate = that.timeValue;
      let data = {
        ProductId: ProductId,
        SearchDate: common.getTime(SearchDate)
      };
      stockApi.getStockDept(data).then(res => {
        that.getSalesByDept(data).then(result => {
          if (result.length > 0) {
            that.tableDataStockDept = res.map(item => {
              let temp = item;
              temp.numx = 0;
              for (let obj of result) {
                if (obj.deptName == temp.deptName) {
                  temp.numx = obj.num;
                }
              }
              return temp;
            });
          } else {
            that.tableDataStockDept = res.map(item => {
              let temp = item;
              temp.numx = 0;
              return temp;
            });
          }
        });
      });
    },
    // 各门店库销售
    getSalesByDept (data) {
      //console.log("getSalesByDept");
      return new Promise((resolve, reject) => {
        salesApi
          .getSalesByDept(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 销售明细
    getSalesDetail (ProductId) {
      let that = this;
      let DeptId = that.deptValue;
      let SearchDate = that.timeValue;
      let data = {
        productId: ProductId,
        deptId: DeptId.filter(item => item != 'all'),
        salesDate: common.getTime(SearchDate)
      };
      salesApi.getSalesDetail(data).then(
        res => {
          that.tableDataSalesDetail = res.map((value, key, arr) => {
            value.salesDate = common.getTimeDetail(value.salesDate);
            return value;
          });
          if (res.length > 0) {
            that.rowclickSalesDetail(res[0]);
          } else {
            that.tableDataSalesProduct = [];
          }
        },
        err => { }
      );
    },
    // 单品月明细
    getStockMonthLy (ProductId) {
      //console.log("getStockMonthLy");
      let that = this;
      let DeptId = that.deptValue;
      let SearchDate = that.timeValue;
      let data = {
        productId: ProductId,
        deptId: DeptId.filter(item => item != 'all'),
        searchDate: common.getTime(SearchDate),
        timeFlag: that.timeFiveValue == '17:00' ? 0 : 1 // 0查询五点后数据  1查询3点后数据
      };
      stockApi.getStockMonthLy(data).then(
        res => {
          // alert(JSON.stringify(res));
          that.columnStockMonthLy = [];
          that.tableDataStockMonthLy = [];
          let columnArr = [{ column: "name", day: "" }];
          columnArr.push({
            column: 'weekendItem',
            time: '周五至周日',
            day: common.getDay(res.weekendItem.updateDate) + ""
          });
          columnArr.push({
            column: 'weekDayItem',
            time: '周一至周四',
            day: common.getDay(res.weekDayItem.updateDate) + ""
          });
          let salesAmountArr = { name: "销量" };
          let salesNumFivePerentArr = { name: (this.timeFiveValue == '17:00' ? '5' : '3') + "点后(占比)" };
          let stockAmountArr = { name: "库存" };
          let returnAmountArr = { name: "退货" };
          // let averSalesAmountArr = { name: "平均销量" };
          let lastSalesDateArr = { name: "末笔" };
          that.dataMonthLy1 = [];
          that.dataMonthLy2 = [];
          that.dataMonthLy3 = [];
          that.dataMonthLy4 = [];
          that.dataMonthLy5 = [];
          that.dataArrMonthLy = ['周五至周日', '周一至周四'];
          that.averSalesAmount = res.averSalesAmount //平均销售
          that.price = res.price;// 单价
          that.quality = res.quality;//保质期
          res.items.map((item, index) => {
            let column = common.getMonthDate(item.updateDate) + "";
            columnArr.push({
              column: column,
              time: common.getDate(item.updateDate) + "",
              day: common.getDay(item.updateDate) + ""
            });
            // that.dataArrMonthLy.push(column);
            that.dataArrMonthLy.push(common.getDate(item.updateDate));
            salesAmountArr[column] = item.salesAmount;
            that.dataMonthLy1.push(item.salesAmount);
            stockAmountArr[column] = item.stockAmount;
            that.dataMonthLy2.push(item.stockAmount);
            returnAmountArr[column] = item.returnAmount;
            that.dataMonthLy3.push(item.returnAmount);
            // 5\3点后占比
            salesNumFivePerentArr[column] = parseFloat(item.salesNumFive) + "(" + parseFloat(common.toDecimal2(item.salesNumFivePercent + "")) + '%)'; // 5\3点后（占比）
            that.dataMonthLy5.push(item.salesNumFive);
            // if (index == 0) {
            //   averSalesAmountArr[column] = res.averSalesAmount;
            // }
            that.dataMonthLy4.push(res.averSalesAmount);
            lastSalesDateArr[column] = common.getTimeDetail(item.lastSalesDate);
          });
          // 周五至周日、周一至周四数据表头填充 start

          salesAmountArr['weekendItem'] = common.toDecimal2(res.weekendItem.salesAmount);
          salesNumFivePerentArr['weekendItem'] = parseFloat(common.toDecimal2(res.weekendItem.salesNumFive)) + "(" + parseFloat(common.toDecimal2(res.weekendItem.salesNumFivePercent + "")) + '%)';
          stockAmountArr['weekendItem'] = common.toDecimal2(res.weekendItem.stockAmount);
          returnAmountArr['weekendItem'] = common.toDecimal2(res.weekendItem.returnAmount);
          lastSalesDateArr['weekendItem'] = res.weekendItem.lastSalesDate ? common.getTimeDetail(res.weekendItem.lastSalesDate) : ""
          that.dataMonthLy4.push(common.toDecimal2(res.averSalesAmount));

          salesAmountArr['weekDayItem'] = common.toDecimal2(res.weekDayItem.salesAmount);
          salesNumFivePerentArr['weekDayItem'] = parseFloat(common.toDecimal2(res.weekDayItem.salesNumFive)) + "(" + parseFloat(common.toDecimal2(res.weekDayItem.salesNumFivePercent + "")) + '%)';
          stockAmountArr['weekDayItem'] = common.toDecimal2(res.weekDayItem.stockAmount);
          returnAmountArr['weekDayItem'] = common.toDecimal2(res.weekDayItem.returnAmount);
          lastSalesDateArr['weekDayItem'] = res.weekDayItem.lastSalesDate ? common.getTimeDetail(res.weekDayItem.lastSalesDate) : ""
          that.dataMonthLy4.push(common.toDecimal2(res.averSalesAmount));
          // 周五至周日、周一至周四数据表头填充 end
          that.dataMonthLy1 = [common.toDecimal2(res.weekDayItem.salesAmount)].concat(that.dataMonthLy1);
          that.dataMonthLy2 = [common.toDecimal2(res.weekDayItem.stockAmount)].concat(that.dataMonthLy2);
          that.dataMonthLy3 = [common.toDecimal2(res.weekDayItem.returnAmount)].concat(that.dataMonthLy3);
          that.dataMonthLy5 = [common.toDecimal2(res.weekDayItem.salesNumFive)].concat(that.dataMonthLy5);
          that.dataMonthLy1 = [common.toDecimal2(res.weekendItem.salesAmount)].concat(that.dataMonthLy1);
          that.dataMonthLy2 = [common.toDecimal2(res.weekendItem.stockAmount)].concat(that.dataMonthLy2);
          that.dataMonthLy3 = [common.toDecimal2(res.weekendItem.returnAmount)].concat(that.dataMonthLy3);
          that.dataMonthLy5 = [common.toDecimal2(res.weekendItem.salesNumFive)].concat(that.dataMonthLy5);

          that.columnStockMonthLy = columnArr; // 表头
          that.tableDataStockMonthLy.push(salesAmountArr); //销量数据
          that.tableDataStockMonthLy.push(salesNumFivePerentArr); // 5\3点后（占比）数据
          that.tableDataStockMonthLy.push(stockAmountArr); //库存数据
          that.tableDataStockMonthLy.push(returnAmountArr); //退货数据
          // that.tableDataStockMonthLy.push(averSalesAmountArr);
          that.tableDataStockMonthLy.push(lastSalesDateArr); // 末笔时间数据
          that.drawLine4();
        },
        err => { }
      );
    },

    getWarning () {
      let that = this;
      common.getEarlyWarningSet().then(
        res => {
          that.isAutoWarning = res.isAutoWarning;
          that.ruleForm.lowBound = res.lowBound;
          that.ruleForm.heightBound = res.heightBound;
          that.timeSet =
            res.timeSet == undefined || res.timeSet.length <= 0
              ? timeSetOption
              : that.getTime(res.timeSet);
        },
        err => { }
      );
    },
    // 实时库存、销售查询时段设置详情
    getRealTime () {
      return new Promise((resolve, reject) => {
        setApi
          .getRealTime()
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    nextFocus (name, index, e) {
      alert("111")
      let that = this
      e.target.blur() // 或者this.$refs[row.id].blur()
      let str = `${name}${index + 1}`
      // // let obj = that.$refs[name + str]
      // // console.log(obj)
      // this.$refs[str].$el.children[0].focus();
      that.$nextTick(() => {
        //   // that.$refs[name + str].focus()
        that.$refs[str].focus()
      })
      // that.$refs["inputNumber"].focus()
    },
    // nextFocus2 (row, index, e) {
    //   let that = this
    //   e.target.blur() // 或者this.$refs[row.id].blur()
    //   that.$refs[Object.keys(that.$refs)[index + 1]].focus();
    // }
  },
  mounted () {
    let that = this;
    that.height = $("#search-content-h").height() - 305;
    that.width = $("#search-content-h").width() - 20;
    that.dispatchHeight = $("#dispatchCenter").height() - 20;

    loading = that.$loading({
      lock: true,
      text: "拼命加载中",
      spinner: "el-icon-loading",
      background: "rgba(255, 255, 255, 0.6)"
    });
    let data = {
      "areaId": []
    }
    // that.getDept(data), 
    Promise.all([that.getDeptArea(), that.getRealTime()])
      .then(
        res => {
          that.$nextTick(() => {
            loading.close();
          });
          // 区域
          that.deptAreaOptions = [{ id: "all", name: "全选" }].concat(res[0])
          // that.areaValue = that.deptAreaOptions.map(item => {
          //   return item.id
          // })
          // if (!res[0] || res[0].length == 0) {
          //   // that.areaValue = ''
          //   that.deptOptions = []
          // } else if (res[0] && res[0].length == 1) {
          //   // that.areaValue = res[0][0].id
          //   that.changeArea()
          // } else {
          // }
          // that.deptOptions = [
          //   {
          //     deptId: "all",
          //     deptName: "全选"
          //   }
          // ].concat(res[1])
          // that.deptValue =
          //   res[1].length > 0
          //     ? that.deptOptions.map(item => {
          //       return item.deptId;
          //     })
          //     : [];
          that.valueTimes = res[1].minutes
        },
        err => {
          that.$nextTick(() => {
            loading.close();
          });
        }
      )
      .catch(err => {
        that.$nextTick(() => {
          loading.close();
        });
      });

    that.getWarning();
  },
  destroyed () {
    loading.close();
    // loading1.close();
    // loading3.close();
    // loading4.close();
  }
};
</script>
<style lang="less">
.el-table {
  .success-row {
    background: #f7f7f7;
  }
  .wornhigh-row {
    background: #ffa85c;
    color: #fff;
  }
  .wornlow-row {
    background: #4c9aef;
    color: #fff;
  }
}
</style>
<style lang="less">
.loadingcustom {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: fixed;
  z-index: 1000;
  // width: 100%;
  height: 100%;
  color: #409eff;
  background-color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  p {
    margin-top: 2px;
  }
}
.productType-table {
  list-style-type: none;
  overflow: hidden;
  overflow-y: auto;
  > li {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/main/dispatchCenter.20210714备份.vue